import React, { Fragment, useState, useEffect, useRef } from 'react'
import DataTable from 'react-data-table-component';
import { Button, CardBody, Col, Container, DropdownItem, DropdownMenu, DropdownToggle, Form, FormGroup, Input, Label, Media, Row, UncontrolledDropdown } from 'reactstrap';
import { MoreVertical, PlusCircle } from 'react-feather';
import useRbac from '../../../../Hooks/useRbac';
import CommonModal from '../../../UiKits/Modals/common/modal'
import axios from 'axios';
import moment from 'moment';
import Swal from 'sweetalert2';
import { useFormik } from 'formik';
import * as Yup from 'yup'
import { baseURL, imageURL } from '../../../../Services/api/baseURL';
import dummyImg from '../../../../assets/images/product/2.png';
import { Image } from '../../../../AbstractElements';
import { FaPen, FaTrashAlt, FaEye, FaToggleOn, FaToggleOff } from 'react-icons/fa';
import { debounce } from 'lodash';
import Loader from '../../../Loader/Loader';
import ReactCrop, { centerCrop, makeAspectCrop } from 'react-image-crop';
import 'react-image-crop/dist/ReactCrop.css'
import UploadOverlay from '../../../Common/UploadOverlay/UploadOverlay';

export const spinnerData = [{
    id: 33,
    heading: 'Loader 31',
    spinnerClass: 'loader-35'
}]

function ContentManagementTable() {
    const { can, canAny } = useRbac();
    const [editData, setEditData] = useState();
    const [searchTerm, setSearchTerm] = useState('');
    const [AddModal, SetAddmodal] = useState(false);
    const [data, setData] = useState([])
    const [deleteModal, setDeleteModal] = useState(false);
    const [token, setToken] = useState(null);
    const [image, setImage] = useState("");
    const [id, setId] = useState("");
    const [BasicTab, setBasicTab] = useState('storePartner');
    const [currentPage, setCurrentPage] = useState(1);
    const [totalRows, setTotalRows] = useState(0);
    const [perPage, setPerPage] = useState(10);
    const [isLoading, setIsLoading] = useState(false);
    const [loading, setLoading] = useState(false);
    const [files, setFiles] = useState([]);
    const [previews, setPreviews] = useState([]);
    const [selectedImage, setSelectedImage] = useState('');
    const [selectedImages, setSelectedImages] = useState([]);
    const [isPreview, setIsPreview] = useState(false);
    const inputRef = useRef();
    const [images, setImages] = useState([]);
    const imgRefs = useRef([]);
    const [cropList, setCropList] = useState([]);
    const cropperRef = useRef(null);
    const [links, setLinks] = useState([]);
    const [isHeroPreview, setIsHeroPreview] = useState(false);
    const [heroPreviewData, setHeroPreviewData] = useState(null);
    const [categories, setCategories] = useState([]);

    // Fetch categories for the Category Hero Banner selector
    useEffect(() => {
        const fetchCategories = async () => {
            const token = JSON.parse(localStorage.getItem('token'));
            try {
                const res = await axios.get(`${baseURL}/api/admin/get-collections?page=1&limit=1000`,
                    { headers: { Authorization: `${token}` } }
                );
                if (res?.data?.data) setCategories(res.data.data);
            } catch (e) { console.log('Failed to load categories', e); }
        };
        fetchCategories();
    }, []);

    const banner_types = {
        subscribe_banner: "Subscribe Banner",
        festival_banner: "Festival Banner",
        landing_page_banner: "Landing Page Banner",
        category_search_banner: "Category Search Page Banner",
        trade_banner: "Trade Home Banner",
        advertisement_banner: "Advertisement Banner",
        home_hero_banner: "Home Hero Banner",
        category_hero_banner: "Category Hero Banner",
        new_product_banner: "New Product Banner", // 🆕
        none: ""
    };

    // 🆕 Parse hero content JSON safely
    const parseHeroContent = (contentStr) => {
        try { return JSON.parse(contentStr || '{}'); } catch { return {}; }
    };

    useEffect(() => {
        const token = JSON.parse(localStorage.getItem('token'))
        if (token) { setToken(token); return; }
        setToken(null);
    }, []);

    const toggleModal = () => {
        formik.resetForm();
        setId("");
        SetAddmodal(!AddModal);
        setFiles([]);
        setSrc("");
        setImage("");
        setCrop();
        setLoading(false);
        setSelectedImage("");
        setImages([]);
        setLinks([]);
    };

    const debouncedSearch = React.useRef(
        debounce(async (searchTerm) => { setSearchTerm(searchTerm); }, 300)
    ).current;

    function capitalize(word) {
        const lower = word?.toLowerCase();
        return word?.charAt(0).toUpperCase() + lower?.slice(1);
    }

    const getEditData = async (data) => {
        if (data) {
            data.device_type && formik.setFieldValue("device_type", data.device_type);
            data.banner_type && formik.setFieldValue("banner_type", data.banner_type);
            data.theme_type && formik.setFieldValue("theme_type", data.theme_type);
            if (!data.links || !Array.isArray(data.links)) {
                const newLinks = Array(data.images?.length || 0).fill('');
                setLinks(newLinks);
                formik.setFieldValue("links", newLinks);
            }
            if (data?.image) {
                const imgSrc = imageURL + data?.image;
                setFiles(data?.image);
                setSelectedImage(imgSrc)
            }
            if (data?.images && data.images.length > 0) {
                const imgList = [];
                data.images.forEach((img) => { imgList.push(imageURL + img) });
                setFiles(imgList);
                setSelectedImages(imgList)
            }
            // Hero banner (home or category) — parse content JSON back into form fields
            if ((data.banner_type === 'home_hero_banner' || data.banner_type === 'category_hero_banner') && data.content) {
                const parsed = parseHeroContent(data.content);
                formik.setFieldValue('title', data.title || '');
                formik.setFieldValue('hero_status_text', parsed.status_text || '');
                formik.setFieldValue('hero_subtitle', parsed.subtitle || '');
                formik.setFieldValue('hero_btn1_label', parsed.btn_primary?.label || '');
                formik.setFieldValue('hero_btn1_link', parsed.btn_primary?.link || '');
                formik.setFieldValue('hero_btn2_label', parsed.btn_secondary?.label || '');
                formik.setFieldValue('hero_btn2_link', parsed.btn_secondary?.link || '');
            }
            if (data.banner_type === 'category_hero_banner' && data.category_id) {
                formik.setFieldValue('category_id', data.category_id);
            }
        }
    }

    const getData = async () => {
        const token = await JSON.parse(localStorage.getItem("token"))
        try {
            setIsLoading(true);
            const response = await axios.get(
                `${baseURL}/api/content-management/list?page=${currentPage}&limit=${perPage}&search_string=${searchTerm}`,
                { headers: { Authorization: `${token}` } }
            );
            if (response?.data.success) {
                setData(response?.data?.data);
                setTotalRows(response?.data.total);
                setIsLoading(false);
            }
        } catch (error) {
            console.log(error)
            setIsLoading(false);
        }
    }

    const deleteBrand = async (id) => {
        if (window.confirm("Do You Want To Delete this Content?")) {
            const token = await JSON.parse(localStorage.getItem("token"))
            try {
                const data = await axios.delete(`${baseURL}/api/content-management/${id}`, {
                    headers: { Authorization: `${token}` }
                })
                getData();
                Swal.fire({ icon: 'success', title: data?.data?.message })
            } catch (error) {
                console.log(error, 'edit')
            }
        }
    }

    useEffect(() => { getData(); }, [BasicTab, currentPage, perPage, searchTerm]);

    const handleClickPreview = (imageUrl) => {
        setSelectedImages(imageUrl);
        setIsPreview(!isPreview);
    };

    const toggleBannerStatus = async (row) => {
        const token = JSON.parse(localStorage.getItem('token'));
        const action = row.status === 'active' ? 'disable' : 'enable';
        const confirm = await Swal.fire({
            title: `${action === 'disable' ? 'Disable' : 'Enable'} this banner?`,
            text: action === 'disable'
                ? 'The banner will stop appearing on the storefront.'
                : 'The banner will become visible on the storefront.',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#d3178a',
            cancelButtonColor: '#6c757d',
            confirmButtonText: action === 'disable' ? 'Yes, disable it' : 'Yes, enable it',
        });
        if (!confirm.isConfirmed) return;
        try {
            const res = await axios.patch(
                `${baseURL}/api/content-management/${row._id}/status`,
                {},
                { headers: { Authorization: `${token}` } }
            );
            if (res?.data?.success) {
                getData();
                Swal.fire({ title: res.data.message, icon: 'success', confirmButtonColor: '#d3178a' });
            }
        } catch (error) {
            Swal.fire({ title: error?.response?.data?.message || 'Status update failed', icon: 'error', confirmButtonColor: '#d3178a' });
        }
    };

    const formik = useFormik({
        initialValues: {
            device_type: "",
            banner_type: "",
            theme_type: "",
            title: "",
            image: "",
            links: [],
            content: "",
            category_id: "",
            // Hero banner fields (optional)
            hero_status_text: "",
            hero_subtitle: "",
            hero_btn1_label: "",
            hero_btn1_link: "",
            hero_btn2_label: "",
            hero_btn2_link: "",
        },
        validationSchema: Yup.object({
            device_type: Yup.string().required('Device Type is required'),
            banner_type: Yup.string().required('Banner Type is required'),
            theme_type: Yup.string().required('Theme Type is required'),
            links: Yup.array().of(Yup.string().url('Please enter a valid URL or leave empty')),
            // category_id required only for category_hero_banner
            category_id: Yup.string().when('banner_type', {
                is: 'category_hero_banner', then: (s) => s.required('Category is required'), otherwise: (s) => s.optional()
            }),
        }),
        onSubmit: async (values) => {
            setLoading(true);
            const token = await JSON.parse(localStorage.getItem("token"));
            try {
                // Hero banners: image is mandatory
                const isHero = values.banner_type === 'home_hero_banner' || values.banner_type === 'category_hero_banner';
                if (isHero && !id && (!files || files.length === 0)) {
                    setLoading(false);
                    Swal.fire({ title: 'Banner/Background Image is required for hero banners.', icon: 'warning', confirmButtonColor: '#d3178a' });
                    return;
                }

                const formData = new FormData();
                values.device_type && formData.append('device_type', values.device_type);
                values.banner_type && formData.append('banner_type', values.banner_type);
                values.theme_type && formData.append('theme_type', values.theme_type);

                // Hero banner: serialise fields into content JSON + title
                if (values.banner_type === 'home_hero_banner' || values.banner_type === 'category_hero_banner') {
                    values.title && formData.append('title', values.title);
                    const heroContent = JSON.stringify({
                        status_text: values.hero_status_text,
                        subtitle: values.hero_subtitle,
                        btn_primary: { label: values.hero_btn1_label, link: values.hero_btn1_link },
                        btn_secondary: { label: values.hero_btn2_label, link: values.hero_btn2_link },
                    });
                    formData.append('content', heroContent);
                    if (values.banner_type === 'category_hero_banner' && values.category_id) {
                        formData.append('category_id', values.category_id);
                    }
                } else {
                    if (values.links && values.links.length > 0) {
                        const filteredLinks = values.links.filter(link => link && link.trim() !== '');
                        if (filteredLinks.length > 0) {
                            formData.append('links', JSON.stringify(filteredLinks));
                        }
                    }
                }

                if (files && files.length > 0 && files[0] instanceof Blob) {
                    files.forEach((file, index) => {
                        let fileName = `image_${index}.${file.type.split("/")[1]}`;
                        const newFile = new File([file], fileName, { type: file.type });
                        formData.append(`image_${index}`, newFile);
                    });
                } else if (files && files.length > 0 && !(files[0] instanceof Blob)) {
                    // If files is a raw File (not a Blob from canvas crop), append directly
                    const rawFile = files[0];
                    if (rawFile instanceof File) {
                        formData.append('image_0', rawFile);
                    }
                }

                let response;
                if (id) {
                    response = await axios.patch(`${baseURL}/api/content-management/${id}`, formData, {
                        headers: { Authorization: `${token}`, "Content-Type": "multipart/form-data" }
                    })
                } else {
                    response = await axios.post(`${baseURL}/api/content-management/add`, formData, {
                        headers: { Authorization: `${token}`, "Content-Type": "multipart/form-data" }
                    });
                }
                if (response?.data?.success) {
                    setLoading(false)
                    formik.resetForm();
                    toggleModal();
                    getData();
                    Swal.fire({ title: response?.data?.message, icon: "success", confirmButtonColor: "#d3178a" });
                }
            } catch (error) {
                setLoading(false);
                const msg =
                    typeof error?.response?.data?.message === 'string'
                        ? error.response.data.message
                        : error?.message || 'An unexpected error occurred';
                Swal.fire({ title: msg, icon: "error", confirmButtonColor: "#d3178a" });
            }
        },
    });

    const handlePageChange = (page) => { setCurrentPage(page); };
    const handlePerRowsChange = async (newPerPage, page) => { setPerPage(newPerPage); };

    const [src, setSrc] = useState(null);
    const [crop, setCrop] = useState({ aspect: 16 / 5 });
    const imgRef = useRef(null);

    // hero banners: mobile 16:9, website 8:3
    const isHeroBanner = () =>
        formik.values.banner_type === 'home_hero_banner' || formik.values.banner_type === 'category_hero_banner';

 const isNewProductBanner = () => formik.values.banner_type === 'new_product_banner';

    const handleFileSelection = (event) => {
        const selectedFiles = Array.from(event.target.files);
        handleFiles(selectedFiles);
    };

    // 🆕 trade_banner, landing_page_banner, and advertisement_banner all support multiple images
    const isMultiImageBanner = (bannerType) =>
        bannerType === "landing_page_banner" || bannerType === "trade_banner" || bannerType === "advertisement_banner";

    const handleFiles = (fileList) => {
        const newFiles = [];
        const newSrcList = [];
        const newCropList = [];
        const filteredFiles = isMultiImageBanner(formik.values.banner_type) ? fileList : [fileList[0]];

        filteredFiles.forEach((file) => {
            const reader = new FileReader();
            reader.onload = (e) => {
                newFiles.push(file);
                newSrcList.push(e.target.result);
                newCropList.push({ aspect: 16 / 9 });

                if (newFiles.length === filteredFiles.length) {
                    setFiles(newFiles);
                    setImages(newSrcList);
                    setCropList(newCropList);
                    const newLinks = Array(newFiles.length).fill('');
                    setLinks(newLinks);
                    formik.setFieldValue('links', newLinks);
                }
            };
            reader.readAsDataURL(file);
        });
    };

    const onImageLoaded = (image, index) => {
        const { naturalWidth: width, naturalHeight: height } = image.currentTarget;
        let aspectRatio;
        if (formik.values.banner_type === 'new_product_banner') {
            aspectRatio = 3 / 1;
        } else if (formik.values.banner_type === 'home_hero_banner' || formik.values.banner_type === 'category_hero_banner') {
            // Hero banners: follow device type — mobile 16:9, website 8:3
            aspectRatio = formik.values.device_type === 'mobile' ? 16 / 9 : 8 / 3;
        } else if (formik.values.device_type === "mobile") {
            aspectRatio = formik.values.banner_type === "category_search_banner" ? 2.19 / 1 : 1 / 1;
        } else {
            aspectRatio = formik.values.banner_type === "category_search_banner" ? 11 / 1 : 16 / 5;
        }
        const crop = centerCrop(
            makeAspectCrop({ unit: '%', width: 100 }, aspectRatio, width, height),
            width, height
        );
        setCropList(prevCropList => {
            const newCropList = [...prevCropList];
            newCropList[index] = crop;
            return newCropList;
        });
    };

    const onCropComplete = async (crop, index) => {
        const image = imgRefs.current[index];
        const srcContent = image.src;
        let mimeType = "image/jpeg";
        if (srcContent && srcContent.startsWith('data:')) {
            const mimeMatch = srcContent.match(/^data:([^;]+);base64,/);
            if (mimeMatch && mimeMatch[1]) mimeType = mimeMatch[1];
        }
        let blobImg;
        if (mimeType === 'image/gif') {
            blobImg = base64ToBlob(`banner_${index}.gif`, srcContent, 'image/gif');
        } else {
            blobImg = await generateCroppedImage(image, crop, `banner_${index}.jpeg`, 'image/jpeg');
        }
        setFiles(prevFiles => {
            const newFiles = [...prevFiles];
            newFiles[index] = blobImg;
            return newFiles;
        });
    };

    const base64ToBlob = (fileName, base64, mime) => {
        const parts = base64.split(',');
        const byteString = atob(parts[1]);
        const mimeType = parts[0].match(/:(.*?);/)[1];
        const ab = new ArrayBuffer(byteString.length);
        const ia = new Uint8Array(ab);
        for (let i = 0; i < byteString.length; i++) ia[i] = byteString.charCodeAt(i);
        const blob = new Blob([ia], { type: mimeType });
        blob.name = fileName;
        return blob;
    };

    const getAspectRatio = (deviceType, bannerType) => {
        if (bannerType === 'new_product_banner') return '(3:1)';
        if (deviceType === 'mobile') {
            if (bannerType === 'category_search_banner') return '(2.19:1)';
            if (bannerType === 'home_hero_banner' || bannerType === 'category_hero_banner') return '(16:9)';
            return '(1:1)';
        } else {
            if (bannerType === 'category_search_banner') return '(11:1)';
            if (bannerType === 'home_hero_banner' || bannerType === 'category_hero_banner') return '(8:3)';
            return '(16:9)';
        }
    };

    const generateCroppedImageold = (image, crop, fileName, mimeType) => {
        const canvas = document.createElement("canvas");
        const scaleX = image.naturalWidth / image.width;
        const scaleY = image.naturalHeight / image.height;
        const pixelRatio = window.devicePixelRatio;
        canvas.width = crop.width * pixelRatio;
        canvas.height = crop.height * pixelRatio;
        const ctx = canvas.getContext("2d");
        ctx.setTransform(pixelRatio, 0, 0, pixelRatio, 0, 0);
        ctx.imageSmoothingQuality = "high";
        ctx.drawImage(image, crop.x * scaleX, crop.y * scaleY, crop.width * scaleX, crop.height * scaleY, 0, 0, crop.width, crop.height);
        return new Promise((resolve) => {
            canvas?.toBlob((blob) => { blob.name = fileName; resolve(blob); }, mimeType, 1);
        });
    };

    const generateCroppedImage = (image, crop, fileName, mimeType) => {
    const canvas = document.createElement("canvas");
    const scaleX = image.naturalWidth / image.width;
    const scaleY = image.naturalHeight / image.height;

    const cropWidthNatural = crop.width * scaleX;
    const cropHeightNatural = crop.height * scaleY;

    canvas.width = cropWidthNatural;
    canvas.height = cropHeightNatural;

    const ctx = canvas.getContext("2d");
    ctx.imageSmoothingQuality = "high";
    ctx.drawImage(
        image,
        crop.x * scaleX, crop.y * scaleY,
        cropWidthNatural, cropHeightNatural,
        0, 0,
        cropWidthNatural, cropHeightNatural
    );

    return new Promise((resolve) => {
        canvas?.toBlob((blob) => { blob.name = fileName; resolve(blob); }, mimeType, 1);
    });
};

    const renderLinkInputs = () => {
        if (isMultiImageBanner(formik.values.banner_type) && images.length > 0) {
            return images.map((_, index) => (
                <Col xl={6} key={index}>
                    <FormGroup>
                        <Label className="font-medium text-base">
                            Link for Image {index + 1} (Optional)
                        </Label>
                        <Input
                            name={`link_${index}`}
                            onChange={(e) => handleLinkChange(index, e.target.value)}
                            value={links[index] || ''}
                            placeholder={`Enter link for image ${index + 1} (https://example.com)`}
                            type="url"
                        />
                        {formik.touched.links && formik.errors.links && formik.errors.links[index] ? (
                            <span className="error text-danger">{formik.errors.links[index]}</span>
                        ) : null}
                    </FormGroup>
                </Col>
            ));
        } else if (formik.values.banner_type && !isMultiImageBanner(formik.values.banner_type)) {
            return (
                <Col xl={6}>
                    <FormGroup>
                        <Label className="font-medium text-base">Link (Optional)</Label>
                        <Input
                            name="single_link"
                            onChange={(e) => {
                                const newLinks = [e.target.value];
                                setLinks(newLinks);
                                formik.setFieldValue('links', newLinks);
                            }}
                            value={links[0] || ''}
                            placeholder="Enter Banner Link (https://example.com)"
                            type="url"
                        />
                        {formik.touched.links && formik.errors.links && formik.errors.links[0] ? (
                            <span className="error text-danger">{formik.errors.links[0]}</span>
                        ) : null}
                    </FormGroup>
                </Col>
            );
        }
        return null;
    };

    const handleLinkChange = (index, value) => {
        const newLinks = [...links];
        newLinks[index] = value;
        setLinks(newLinks);
        formik.setFieldValue('links', newLinks);
    };

    const orderColumns = [
        {
            name: 'Device', width: '120px',
            selector: row => `${row.device_type}`, sortable: true, center: true,
            cell: (row) => capitalize(row?.device_type)
        },
        {
            name: 'Banner Type', width: '250px',
            selector: row => `${row.banner_type}`, sortable: true, center: true,
            cell: (row) => row?.banner_type ? (banner_types[row?.banner_type] || row?.banner_type) : "N/A"
        },
        {
            name: 'Theme', width: '100px',
            selector: row => `${row.theme_type}`, sortable: true, center: true,
            cell: (row) => capitalize(row?.theme_type)
        },
        {
            name: 'Links',
            selector: row => row?.links, sortable: false, center: false,
            cell: (row) => {
                let linksArray = [];
                if (row?.links) {
                    if (Array.isArray(row.links)) {
                        if (row.links.length > 0 && typeof row.links[0] === 'string') {
                            try { linksArray = JSON.parse(row.links[0]); } catch (e) { return <span className="text-danger">Invalid links format</span>; }
                        } else { linksArray = row.links; }
                    } else if (typeof row.links === 'string') {
                        try { linksArray = JSON.parse(row.links); } catch (e) { return <span className="text-danger">Invalid links format</span>; }
                    }
                }
                linksArray = linksArray.filter(link => link && link.trim() !== '');
                if (linksArray.length > 0) {
                    return (
                        <div className="d-flex flex-column gap-1 py-2">
                            {linksArray.map((link, index) => {
                                const displayText = link.length > 50 ? link.substring(0, 100) + '...' : link;
                                return (
                                    <a key={index} href={link} target="_blank" rel="noopener noreferrer"
                                        className="text-primary text-decoration-none d-block"
                                        style={{ fontSize: '0.675rem', wordBreak: 'break-all', maxWidth: '340px' }}
                                        title={link}>
                                        <span className='text-black'>Link {index + 1}:</span> {displayText}
                                    </a>
                                );
                            })}
                        </div>
                    );
                }
                return <span className="text-muted">No Links</span>;
            }
        },
        {
            name: 'Preview', width: '200px',
            selector: row => row['full_name'], sortable: true, center: false,
            cell: (row) => (
                <>
                    {(row.banner_type === 'home_hero_banner' || row.banner_type === 'category_hero_banner') ? (
                        <Media className='d-flex align-items-center'>
                            <FaEye size={18} color='#d3178a' />
                            <span
                                onClick={() => {
                                    const parsed = parseHeroContent(row.content);
                                    setHeroPreviewData({ ...parsed, title: row.title, bgImage: row.image ? imageURL + row.image : null, device_type: row.device_type });
                                    setIsHeroPreview(true);
                                }}
                                className='ms-2 link-primary cursor-pointer'
                            >
                                Click here to preview
                            </span>
                        </Media>
                    ) : row.images && row.images.length > 0 ? (
                        <Media className='d-flex align-items-center'>
                            <Image attrImage={{ className: 'rounded-circle w-[30px] h-[30px]', src: `${row?.images[0] ? imageURL + row.images[0] : dummyImg}`, alt: 'Banner image' }} />
                            <span onClick={() => handleClickPreview(row.images.map(img => imageURL + img))} className='ms-2 link-primary cursor-pointer'>Click here to preview</span>
                        </Media>
                    ) : (
                        <Media className='d-flex align-items-center'>
                            <Image attrImage={{ className: 'rounded-circle w-[30px] h-[30px]', src: `${row?.image ? imageURL + row.image : dummyImg}`, alt: 'Banner image' }} />
                            <span onClick={() => handleClickPreview(row?.image ? [imageURL + row.image] : [dummyImg])} className='ms-2 link-primary cursor-pointer'>Click here to preview</span>
                        </Media>
                    )}
                </>
            )
        },
        {
            name: 'CREATED', width: '120px',
            selector: row => `${row.createdAt}`,
            cell: (row) => moment(row.createdAt).format("DD MMM, YYYY"),
            sortable: true, center: true,
        },
        {
            name: 'STATUS', width: '110px',
            selector: row => `${row.status}`, sortable: true, center: true,
            cell: (row) => row.status === 'active'
                ? <span style={{ fontSize: '12px' }} className="badge badge-light-success">Active</span>
                : <span style={{ fontSize: '12px' }} className="badge badge-light-danger">Disabled</span>
        },
        {
            name: 'Actions', width: '120px',
            omit: !canAny(['content.update', 'content.delete']),
            cell: (row) => (
                <UncontrolledDropdown className='action_dropdown'>
                    <DropdownToggle className='action_btn'><MoreVertical color='#000' size={16} /></DropdownToggle>
                    <DropdownMenu>
                        {/* Preview action for home/category hero banners */}
                        {(row.banner_type === 'home_hero_banner' || row.banner_type === 'category_hero_banner') && (
                            <DropdownItem onClick={() => {
                                const parsed = parseHeroContent(row.content);
                                setHeroPreviewData({ ...parsed, title: row.title, bgImage: row.image ? imageURL + row.image : null, device_type: row.device_type });
                                setIsHeroPreview(true);
                            }}>
                                Preview <FaEye />
                            </DropdownItem>
                        )}
                        {can('content.update') && (
                            <DropdownItem onClick={() => {
                                formik.resetForm(); getEditData(row); setId(row?._id); SetAddmodal(true)
                            }}>
                                Edit <FaPen />
                            </DropdownItem>
                        )}
                        {/* Enable / Disable toggle */}
                        {can('content.update') && (
                            <DropdownItem
                                onClick={() => toggleBannerStatus(row)}
                                className={row.status === 'active' ? 'text-warning' : 'text-success'}
                            >
                                {row.status === 'active' ? 'Disable' : 'Enable'}
                                {' '}{row.status === 'active' ? <FaToggleOff /> : <FaToggleOn />}
                            </DropdownItem>
                        )}
                        {can('content.delete') && (
                            <DropdownItem className='delete_item' onClick={() => deleteBrand(row?._id)}>
                                Delete <FaTrashAlt />
                            </DropdownItem>
                        )}
                    </DropdownMenu>
                </UncontrolledDropdown>
            ),
            sortable: false, center: true,
        }
    ];

    return (
        <Fragment>
            <CardBody style={{ padding: '15px' }}>
                <Row xxl={12} className='pb-2'>
                    <Row>
                        <Col md={6} lg={6} xl={6} xxl={6}>
                            <h5 className="fw-bolder">Banners</h5>
                        </Col>
                        <Col md={6} lg={6} xl={6} xxl={6}>
                            <div className="file-content file-content1 justify-content-end">
                                <div className='mb-0 form-group position-relative search_outer d-flex align-items-center'>
                                    <i className='fa fa-search' style={{ top: 'unset' }}></i>
                                    <input className='form-control border-0' style={{ maxWidth: '195px' }} onChange={(e) => debouncedSearch(e.target.value)} type='text' placeholder='Search...' />
                                </div>
                                {can('content.create') && (
                                    <Button className='btn btn-primary d-flex align-items-center ms-3' onClick={toggleModal}>
                                        <PlusCircle /> Add Banner
                                    </Button>
                                )}
                            </div>
                        </Col>
                    </Row>
                </Row>
            </CardBody>

            <DataTable
                data={data}
                columns={orderColumns}
                striped={true}
                center={true}
                pagination
                paginationServer
                progressComponent={<Loader />}
                progressPending={isLoading}
                paginationTotalRows={totalRows}
                onChangeRowsPerPage={handlePerRowsChange}
                onChangePage={handlePageChange}
            />

            <CommonModal isOpen={AddModal} title={id ? 'Update Banner' : 'Add a New Banner'} className="store_modal" toggler={toggleModal} size="xl">
                <Container>
                    <Form onSubmit={formik.handleSubmit}>
                        <Row>
                            <Col xl={6}>
                                <FormGroup>
                                    <Label className="font-medium text-base">Device Type <span className="text-danger">*</span></Label>
                                    <Input type="select" name="device_type" onChange={formik.handleChange} onBlur={formik.handleBlur} value={formik.values.device_type}>
                                        <option value="" disabled label="Select Device Type" />
                                        <option value="mobile" label="Mobile" />
                                        <option value="website" label="Website" />
                                    </Input>
                                    {formik.touched.device_type && formik.errors.device_type && <span className="error text-danger">{formik.errors.device_type}</span>}
                                </FormGroup>
                            </Col>

                            <Col xl={6}>
                                <FormGroup>
                                    <Label className="font-medium text-base">Banner Type <span className="text-danger">*</span></Label>
                                    <Input type="select" name="banner_type" onChange={formik.handleChange} onBlur={formik.handleBlur} value={formik.values.banner_type}>
                                        <option value="" disabled label="Select Banner Type" />
                                        <option value="landing_page_banner" label={`Landing Page Banner ${getAspectRatio(formik.values.device_type, 'landing_page_banner')}`} />
                                        <option value="festival_banner" label={`Festival Banner ${getAspectRatio(formik.values.device_type, 'festival_banner')}`} />
                                        <option value="subscribe_banner" label={`Subscribe Banner ${getAspectRatio(formik.values.device_type, 'subscribe_banner')}`} />
                                        <option value="category_search_banner" label={`Category Search Page Banner ${getAspectRatio(formik.values.device_type, 'category_search_banner')}`} />
                                        <option value="trade_banner" label={`Trade Home Banner ${getAspectRatio(formik.values.device_type, 'trade_banner')}`} />
                                        <option value="advertisement_banner" label={`Advertisement Banner ${getAspectRatio(formik.values.device_type, 'advertisement_banner')}`} />
                                        <option value="home_hero_banner" label={`Home Hero Banner ${getAspectRatio(formik.values.device_type, 'home_hero_banner')}`} />
                                        <option value="category_hero_banner" label={`Category Hero Banner ${getAspectRatio(formik.values.device_type, 'category_hero_banner')}`} />
                                        <option value="new_product_banner" label={`New Product Banner ${getAspectRatio(formik.values.device_type, 'new_product_banner')}`} />
                                    </Input>
                                    {formik.touched.banner_type && formik.errors.banner_type && <span className="error text-danger">{formik.errors.banner_type}</span>}

                                    {/* 🆕 Helper text for trade banner */}
                                    {formik.values.banner_type === "trade_banner" && (
                                        <div className="mt-1 p-2 rounded" style={{ background: "#fff0f7", border: "1px solid #f9a8d4" }}>
                                            <small className="text-danger font-weight-bold">
                                                🏢 Trade Banner — shown only to approved B2B/Trade account users on the homepage.
                                                Upload separate banners for mobile and website.
                                            </small>
                                        </div>
                                    )}
                                    {/* 🆕 Helper text for advertisement banner */}
                                    {formik.values.banner_type === "advertisement_banner" && (
                                        <div className="mt-1 p-2 rounded" style={{ background: "#f0f7ff", border: "1px solid #a8d4f9" }}>
                                            <small className="text-primary font-weight-bold">
                                                📢 Advertisement Banner — supports multiple images displayed as a slider on the home page.
                                                Upload separate banners for mobile and website.
                                            </small>
                                        </div>
                                    )}
                                   {formik.values.banner_type === "new_product_banner" && (
                                        <div className="mt-1 p-2 rounded" style={{ background: "#f0fff4", border: "1px solid "+"#a8f9c8" }}>
                                            <small className="text-success font-weight-bold">
                                                🆕 New Product Banner — highlights newly launched products, fixed 3:1 ratio for both mobile and website.
                                            </small>
                                        </div>
                                    )}
                                </FormGroup>
                            </Col>

                            <Col xl={6}>
                                <FormGroup>
                                    <Label className="font-medium text-base">Select Theme Type <span className="text-danger">*</span></Label>
                                    <Input type="select" name="theme_type" onChange={formik.handleChange} onBlur={formik.handleBlur} value={formik.values.theme_type}>
                                        <option value="" disabled label="Select Theme Type" />
                                        <option value="light" label="Light" />
                                        <option value="dark" label="Dark" />
                                    </Input>
                                    {formik.touched.theme_type && formik.errors.theme_type && <span className="error text-danger">{formik.errors.theme_type}</span>}
                                </FormGroup>
                            </Col>

                            {/* Home Hero Banner OR Category Hero Banner — 5-field section (all optional) */}
                            {(formik.values.banner_type === 'home_hero_banner' || formik.values.banner_type === 'category_hero_banner') && (
                                <>
                                    <Col xl={12}>
                                        <div className="p-3 rounded mb-3" style={{ background: '#f0f4ff', border: '1px solid #b8c8ff' }}>
                                            <small className="text-primary fw-bold">
                                                {formik.values.banner_type === 'home_hero_banner'
                                                    ? <><strong>Home Hero Banner</strong> — configures the left-side hero copy on the homepage. Multiple records can exist; toggle Active/Inactive to control which is live.</>
                                                    : <><strong>Category Hero Banner</strong> — configures the hero copy shown on a specific category page. Select the category below.</>}
                                            </small>
                                        </div>
                                    </Col>

                                    {/* Category selector — only for category_hero_banner */}
                                    {formik.values.banner_type === 'category_hero_banner' && (
                                        <Col xl={12}>
                                            <FormGroup>
                                                <Label className="font-medium text-base">Category <span className="text-danger">*</span></Label>
                                                <Input type="select" name="category_id" onChange={formik.handleChange} onBlur={formik.handleBlur} value={formik.values.category_id}>
                                                    <option value="" disabled>Select Category</option>
                                                    {categories.map(cat => (
                                                        <option key={cat._id} value={cat._id}>{cat.collection_name}</option>
                                                    ))}
                                                </Input>
                                                {formik.touched.category_id && formik.errors.category_id && <span className="error text-danger">{formik.errors.category_id}</span>}
                                            </FormGroup>
                                        </Col>
                                    )}

                                    {/* Field 1 — Status Line (optional) */}
                                    <Col xl={12}>
                                        <FormGroup>
                                            <Label className="font-medium text-base">1. Status Line <small className="text-muted">(optional — dot badge text, e.g. "Store open · delivering across Melbourne's north")</small></Label>
                                            <Input
                                                name="hero_status_text"
                                                onChange={formik.handleChange}
                                                onBlur={formik.handleBlur}
                                                value={formik.values.hero_status_text}
                                                placeholder="Store open · delivering across Melbourne's north"
                                            />
                                        </FormGroup>
                                    </Col>

                                    {/* Field 2 — Hero Headline (optional) */}
                                    <Col xl={12}>
                                        <FormGroup>
                                            <Label className="font-medium text-base">2. Hero Headline <small className="text-muted">(optional — main title, e.g. "Cold drinks, delivered in 33 minutes.")</small></Label>
                                            <Input
                                                name="title"
                                                onChange={formik.handleChange}
                                                onBlur={formik.handleBlur}
                                                value={formik.values.title}
                                                placeholder="Cold drinks, delivered in 33 minutes."
                                            />
                                        </FormGroup>
                                    </Col>

                                    {/* Field 3 — Sub-Heading (optional) */}
                                    <Col xl={12}>
                                        <FormGroup>
                                            <Label className="font-medium text-base">3. Sub-Heading <small className="text-muted">(optional — e.g. "Faster than the drive. Colder than the shop. Free over $18.")</small></Label>
                                            <Input
                                                name="hero_subtitle"
                                                onChange={formik.handleChange}
                                                onBlur={formik.handleBlur}
                                                value={formik.values.hero_subtitle}
                                                placeholder="Faster than the drive. Colder than the shop. Free over $18."
                                            />
                                        </FormGroup>
                                    </Col>

                                    {/* Field 4 — Primary Button (optional) */}
                                    <Col xl={6}>
                                        <FormGroup>
                                            <Label className="font-medium text-base">4. Primary Button Label <small className="text-muted">(optional)</small></Label>
                                            <Input
                                                name="hero_btn1_label"
                                                onChange={formik.handleChange}
                                                onBlur={formik.handleBlur}
                                                value={formik.values.hero_btn1_label}
                                                placeholder="Shop deals"
                                            />
                                        </FormGroup>
                                    </Col>
                                    <Col xl={6}>
                                        <FormGroup>
                                            <Label className="font-medium text-base">4. Primary Button Link <small className="text-muted">(optional)</small></Label>
                                            <Input
                                                name="hero_btn1_link"
                                                onChange={formik.handleChange}
                                                onBlur={formik.handleBlur}
                                                value={formik.values.hero_btn1_link}
                                                placeholder="/collections/biggest-savings"
                                            />
                                        </FormGroup>
                                    </Col>

                                    {/* Field 5 — Secondary Button (optional) */}
                                    <Col xl={6}>
                                        <FormGroup>
                                            <Label className="font-medium text-base">5. Secondary Button Label <small className="text-muted">(optional)</small></Label>
                                            <Input
                                                name="hero_btn2_label"
                                                onChange={formik.handleChange}
                                                onBlur={formik.handleBlur}
                                                value={formik.values.hero_btn2_label}
                                                placeholder="Reorder my usuals"
                                            />
                                        </FormGroup>
                                    </Col>
                                    <Col xl={6}>
                                        <FormGroup>
                                            <Label className="font-medium text-base">5. Secondary Button Link <small className="text-muted">(optional)</small></Label>
                                            <Input
                                                name="hero_btn2_link"
                                                onChange={formik.handleChange}
                                                onBlur={formik.handleBlur}
                                                value={formik.values.hero_btn2_link}
                                                placeholder="/account/orders"
                                            />
                                        </FormGroup>
                                    </Col>
                                </>
                            )}

                            {/* Non-hero banners: show link inputs */}
                            {formik.values.banner_type !== 'home_hero_banner' && formik.values.banner_type !== 'category_hero_banner' && renderLinkInputs()}

                            <Col xl={6}>
                                <FormGroup>
                                    <Label className="font-medium text-base">
                                        {(formik.values.banner_type === 'home_hero_banner' || formik.values.banner_type === 'category_hero_banner')
                                            ? <>Banner/Background Image <span className="text-danger">*</span></>   
                                            : 'Banner Image'}
                                        {formik.values.banner_type !== 'home_hero_banner' && formik.values.banner_type !== 'category_hero_banner' && <span className="text-danger"> *</span>}
                                        {formik.values.banner_type === "trade_banner" && (
                                            <small className="text-muted ml-2">(Multiple images supported — will show as slider)</small>
                                        )}
                                        {formik.values.banner_type === "advertisement_banner" && (
                                            <small className="text-muted ml-2">(Multiple images supported — will show as slider)</small>
                                        )}
                                        {formik.values.banner_type === "new_product_banner" && (
                                            <small className="text-muted ml-2">(3:1 ratio)</small>
                                        )}
                                    </Label>
                                    <CardBody>
                                        <Form>
                                            <input
                                                type="file"
                                                multiple={isMultiImageBanner(formik.values.banner_type)}
                                                onChange={handleFileSelection}
                                                hidden
                                                accept="image/png, image/jpeg, image/gif"
                                                ref={inputRef}
                                            />
                                            <button type="button" className='btn btn-secondary' onClick={() => inputRef.current.click()}>
                                                Browse Files
                                            </button>
                                        </Form>
                                    </CardBody>
                                </FormGroup>
                            </Col>

                            <Col xl={12}>
                                <div className='mt-3'>
                                    {images.length > 0 ? (
                                        images.map((image, index) => (
                                            <ReactCrop
                                                key={index}
                                                crop={cropList[index]}
                                                onChange={newCrop => setCropList(prevCrops => {
                                                    const newCrops = [...prevCrops];
                                                    newCrops[index] = newCrop;
                                                    return newCrops;
                                                })}
                                                onComplete={() => onCropComplete(cropList[index], index)}
                                                aspect={
                                                    isNewProductBanner()
                                                        ? 3 / 1
                                                        : isHeroBanner()
                                                            ? (formik.values.device_type === 'mobile' ? 16 / 9 : 8 / 3)
                                                            : formik.values.device_type === "mobile"
                                                                ? 1 / 1
                                                                : formik.values.banner_type === "category_search_banner"
                                                                    ? 11 / 1
                                                                    : 16 / 5
                                                }
                                                keepSelection={true}
                                                minWidth={
                                                    isNewProductBanner()
                                                        ? 900
                                                        : isHeroBanner()
                                                            ? (formik.values.device_type === 'mobile' ? 640 : 1920)
                                                            : formik.values.device_type === "mobile" ? 500 : 1920
                                                }
                                                minHeight={
                                                    isNewProductBanner()
                                                        ? 300
                                                        : isHeroBanner()
                                                            ? (formik.values.device_type === 'mobile' ? 360 : 720)
                                                            : formik.values.device_type === "mobile" ? 500 : (formik.values.banner_type === "category_search_banner" ? 175 : 500)
                                                }
                                            >
                                                <img
                                                    ref={el => (imgRefs.current[index] = el)}
                                                    src={image}
                                                    onLoad={(e) => onImageLoaded(e, index)}
                                                    alt=''
                                                />
                                            </ReactCrop>
                                        ))
                                    ) : (
                                        <img src={selectedImage} alt='' />
                                    )}
                                </div>

                                {(formik.values.banner_type === 'home_hero_banner' || formik.values.banner_type === 'category_hero_banner') && (
                                    <div className='mt-4'>
                                        <Label className="fw-bold mb-2">Live Preview</Label>
                                        <HeroPreviewPanel
                                            statusText={formik.values.hero_status_text}
                                            title={formik.values.title}
                                            subtitle={formik.values.hero_subtitle}
                                            btn1Label={formik.values.hero_btn1_label}
                                            btn1Link={formik.values.hero_btn1_link}
                                            btn2Label={formik.values.hero_btn2_label}
                                            bgImage={images[0] || selectedImage || null}
                                            deviceType={formik.values.device_type}
                                        />
                                    </div>
                                )}
                            </Col>

                            <Col xl={12} className="modal_btm d-flex justify-content-end">
                                <Button className="cancel_Btn" onClick={() => { setImages([]); SetAddmodal(false) }}>Cancel</Button>
                                <Button type="submit" disabled={loading} className='btn btn-primary d-flex align-items-center ms-3'>
                                    {loading ? 'Uploading…' : (id ? 'Update Banner' : 'Add Banner')}
                                </Button>
                            </Col>
                        </Row>
                    </Form>
                    <UploadOverlay
                        isVisible={loading}
                        message={id ? 'Updating banner…' : 'Saving banner…'}
                    />
                </Container>
            </CommonModal>


            <CommonModal isOpen={isPreview} className="store_modal" toggler={() => setIsPreview(!isPreview)} size="lg">
                <Container>
                    <Row>
                        {selectedImages.map && selectedImages.map((image, index) => (
                            <Col xl={12} md={12} sm={12} key={index}>
                                <img src={image} className='w-100' alt={`banner-${index}`} />
                            </Col>
                        ))}
                    </Row>
                </Container>
            </CommonModal>

           <CommonModal
                isOpen={isHeroPreview}
                title="Hero Banner Preview"
                className="store_modal"
                toggler={() => setIsHeroPreview(false)}
                size="xl"
            >
                <Container fluid>
                    {heroPreviewData && (
                        <HeroPreviewPanel
                            statusText={heroPreviewData.status_text}
                            title={heroPreviewData.title}
                            subtitle={heroPreviewData.subtitle}
                            btn1Label={heroPreviewData.btn_primary?.label}
                            btn1Link={heroPreviewData.btn_primary?.link}
                            btn2Label={heroPreviewData.btn_secondary?.label}
                            bgImage={heroPreviewData.bgImage}
                            deviceType={heroPreviewData.device_type}
                        />
                    )}
                </Container>
            </CommonModal>
        </Fragment>
    )
}

function HeroPreviewPanel({ statusText, title, subtitle, btn1Label, btn1Link, btn2Label, bgImage, deviceType }) {
    const hasAnyContent = statusText || title || subtitle || btn1Label || btn2Label;
    const isMobile = deviceType === 'mobile';
    return (
        <div style={{
            background: bgImage ? `url(${bgImage}) center/cover no-repeat` : 'linear-gradient(135deg, #1a1a2e 0%, #16213e 50%, #0f3460 100%)',
            borderRadius: '12px',
            ...(isMobile
                ? { aspectRatio: '16 / 9', width: '100%', maxWidth: '480px', padding: '24px' }
                : { aspectRatio: '8 / 3', width: '100%', padding: '48px 40px' }
            ),
            display: 'flex',
            alignItems: isMobile ? 'flex-end' : 'center',
            position: 'relative',
            overflow: 'hidden',
        }}>
            {bgImage && <div style={{ position: 'absolute', inset: 0, background: 'rgba(0,0,0,0.45)', borderRadius: '12px' }} />}
            {hasAnyContent && (
                <div style={{ position: 'relative', zIndex: 1, maxWidth: '520px' }}>
                    {/* Status dot badge — only if provided */}
                    {statusText && (
                        <p style={{ display: 'flex', alignItems: 'center', gap: '8px', color: '#a3e635', fontSize: '13px', fontWeight: 600, marginBottom: '16px', letterSpacing: '0.02em' }}>
                            <span style={{ width: '8px', height: '8px', borderRadius: '50%', background: '#a3e635', display: 'inline-block', boxShadow: '0 0 8px #a3e635' }} />
                            {statusText}
                        </p>
                    )}

                    {/* Headline — only if provided */}
                    {title && (
                        <h1 style={{ color: '#fff', fontSize: '2.2rem', fontWeight: 800, lineHeight: 1.15, margin: '0 0 14px' }}>
                            {title}
                        </h1>
                    )}

                    {/* Sub-heading — only if provided */}
                    {subtitle && (
                        <p style={{ color: '#cbd5e1', fontSize: '15px', marginBottom: '28px', lineHeight: 1.6 }}>{subtitle}</p>
                    )}

                    {/* Buttons — only render the row if at least one button label exists */}
                    {(btn1Label || btn2Label) && (
                        <div style={{ display: 'flex', gap: '12px', flexWrap: 'wrap' }}>
                            {btn1Label && (
                                <span style={{
                                    background: '#d3178a', color: '#fff', padding: '10px 24px',
                                    borderRadius: '8px', fontWeight: 700, fontSize: '14px', cursor: 'default',
                                    boxShadow: '0 4px 14px rgba(211,23,138,0.4)'
                                }}>{btn1Label}</span>
                            )}
                            {btn2Label && (
                                <span style={{
                                    background: 'transparent', color: '#fff', padding: '10px 24px',
                                    borderRadius: '8px', fontWeight: 600, fontSize: '14px', cursor: 'default',
                                    border: '1.5px solid rgba(255,255,255,0.35)'
                                }}>{btn2Label}</span>
                            )}
                        </div>
                    )}
                </div>
            )}
        </div>
    );
}

export default ContentManagementTable;


// import React, { Fragment, useState, useEffect, useRef } from 'react'
// import DataTable from 'react-data-table-component';
// import { Button, CardBody, Col, Container, DropdownItem, DropdownMenu, DropdownToggle, Form, FormGroup, Input, InputGroup, InputGroupText, Label, Media, Nav, NavItem, NavLink, Row, UncontrolledDropdown } from 'reactstrap';
// import { MoreVertical, PlusCircle } from 'react-feather';
// import useRbac from '../../../../Hooks/useRbac';
// import CommonModal from '../../../UiKits/Modals/common/modal'
// import axios from 'axios';
// import moment from 'moment';
// import Swal from 'sweetalert2';
// import { useFormik } from 'formik';
// import * as Yup from 'yup'
// import { baseURL, imageURL } from '../../../../Services/api/baseURL';
// import dummyImg from '../../../../assets/images/product/2.png';
// import { Image } from '../../../../AbstractElements';
// import { FaPen, FaTrashAlt, FaEye, FaToggleOn, FaToggleOff } from 'react-icons/fa';
// import { debounce } from 'lodash';
// import Loader from '../../../Loader/Loader';
// import ReactCrop, { centerCrop, makeAspectCrop } from 'react-image-crop';
// import 'react-image-crop/dist/ReactCrop.css'
// import UploadOverlay from '../../../Common/UploadOverlay/UploadOverlay';

// export const spinnerData = [{
//     id: 33,
//     heading: 'Loader 31',
//     spinnerClass: 'loader-35'
// }]

// function ContentManagementTable() {
//     const { can, canAny } = useRbac();
//     const [editData, setEditData] = useState();
//     const [searchTerm, setSearchTerm] = useState('');
//     const [AddModal, SetAddmodal] = useState(false);
//     const [data, setData] = useState([])
//     const [deleteModal, setDeleteModal] = useState(false);
//     const [token, setToken] = useState(null);
//     const [image, setImage] = useState("");
//     const [id, setId] = useState("");
//     const [BasicTab, setBasicTab] = useState('storePartner');
//     const [currentPage, setCurrentPage] = useState(1);
//     const [totalRows, setTotalRows] = useState(0);
//     const [perPage, setPerPage] = useState(10);
//     const [isLoading, setIsLoading] = useState(false);
//     const [loading, setLoading] = useState(false);
//     const [files, setFiles] = useState([]);
//     const [previews, setPreviews] = useState([]);
//     const [selectedImage, setSelectedImage] = useState('');
//     const [selectedImages, setSelectedImages] = useState([]);
//     const [isPreview, setIsPreview] = useState(false);
//     const inputRef = useRef();
//     const [images, setImages] = useState([]);
//     const imgRefs = useRef([]);
//     const [cropList, setCropList] = useState([]);
//     const cropperRef = useRef(null);
//     const [links, setLinks] = useState([]);
//     const [isHeroPreview, setIsHeroPreview] = useState(false);
//     const [heroPreviewData, setHeroPreviewData] = useState(null);
//     const [categories, setCategories] = useState([]);

//     // Fetch categories for the Category Hero Banner selector
//     useEffect(() => {
//         const fetchCategories = async () => {
//             const token = JSON.parse(localStorage.getItem('token'));
//             try {
//                 const res = await axios.get(`${baseURL}/api/admin/get-collections?page=1&limit=1000`,
//                     { headers: { Authorization: `${token}` } }
//                 );
//                 if (res?.data?.data) setCategories(res.data.data);
//             } catch (e) { console.log('Failed to load categories', e); }
//         };
//         fetchCategories();
//     }, []);

//     const banner_types = {
//         subscribe_banner: "Subscribe Banner",
//         festival_banner: "Festival Banner",
//         landing_page_banner: "Landing Page Banner",
//         category_search_banner: "Category Search Page Banner",
//         trade_banner: "Trade Home Banner",
//         advertisement_banner: "Advertisement Banner",
//         home_hero_banner: "Home Hero Banner",
//         category_hero_banner: "Category Hero Banner",
//         none: ""
//     };

//     // 🆕 Parse hero content JSON safely
//     const parseHeroContent = (contentStr) => {
//         try { return JSON.parse(contentStr || '{}'); } catch { return {}; }
//     };

//     useEffect(() => {
//         const token = JSON.parse(localStorage.getItem('token'))
//         if (token) { setToken(token); return; }
//         setToken(null);
//     }, []);

//     const toggleModal = () => {
//         formik.resetForm();
//         setId("");
//         SetAddmodal(!AddModal);
//         setFiles([]);
//         setSrc("");
//         setImage("");
//         setCrop();
//         setLoading(false);
//         setSelectedImage("");
//         setImages([]);
//         setLinks([]);
//     };

//     const debouncedSearch = React.useRef(
//         debounce(async (searchTerm) => { setSearchTerm(searchTerm); }, 300)
//     ).current;

//     function capitalize(word) {
//         const lower = word?.toLowerCase();
//         return word?.charAt(0).toUpperCase() + lower?.slice(1);
//     }

//     const getEditData = async (data) => {
//         if (data) {
//             data.device_type && formik.setFieldValue("device_type", data.device_type);
//             data.banner_type && formik.setFieldValue("banner_type", data.banner_type);
//             data.theme_type && formik.setFieldValue("theme_type", data.theme_type);
//             if (!data.links || !Array.isArray(data.links)) {
//                 const newLinks = Array(data.images?.length || 0).fill('');
//                 setLinks(newLinks);
//                 formik.setFieldValue("links", newLinks);
//             }
//             if (data?.image) {
//                 const imgSrc = imageURL + data?.image;
//                 setFiles(data?.image);
//                 setSelectedImage(imgSrc)
//             }
//             if (data?.images && data.images.length > 0) {
//                 const imgList = [];
//                 data.images.forEach((img) => { imgList.push(imageURL + img) });
//                 setFiles(imgList);
//                 setSelectedImages(imgList)
//             }
//             // Hero banner (home or category) — parse content JSON back into form fields
//             if ((data.banner_type === 'home_hero_banner' || data.banner_type === 'category_hero_banner') && data.content) {
//                 const parsed = parseHeroContent(data.content);
//                 formik.setFieldValue('title', data.title || '');
//                 formik.setFieldValue('hero_status_text', parsed.status_text || '');
//                 formik.setFieldValue('hero_subtitle', parsed.subtitle || '');
//                 formik.setFieldValue('hero_btn1_label', parsed.btn_primary?.label || '');
//                 formik.setFieldValue('hero_btn1_link', parsed.btn_primary?.link || '');
//                 formik.setFieldValue('hero_btn2_label', parsed.btn_secondary?.label || '');
//                 formik.setFieldValue('hero_btn2_link', parsed.btn_secondary?.link || '');
//             }
//             if (data.banner_type === 'category_hero_banner' && data.category_id) {
//                 formik.setFieldValue('category_id', data.category_id);
//             }
//         }
//     }

//     const getData = async () => {
//         const token = await JSON.parse(localStorage.getItem("token"))
//         try {
//             setIsLoading(true);
//             const response = await axios.get(
//                 `${baseURL}/api/content-management/list?page=${currentPage}&limit=${perPage}&search_string=${searchTerm}`,
//                 { headers: { Authorization: `${token}` } }
//             );
//             if (response?.data.success) {
//                 setData(response?.data?.data);
//                 setTotalRows(response?.data.total);
//                 setIsLoading(false);
//             }
//         } catch (error) {
//             console.log(error)
//             setIsLoading(false);
//         }
//     }

//     const deleteBrand = async (id) => {
//         if (window.confirm("Do You Want To Delete this Content?")) {
//             const token = await JSON.parse(localStorage.getItem("token"))
//             try {
//                 const data = await axios.delete(`${baseURL}/api/content-management/${id}`, {
//                     headers: { Authorization: `${token}` }
//                 })
//                 getData();
//                 Swal.fire({ icon: 'success', title: data?.data?.message })
//             } catch (error) {
//                 console.log(error, 'edit')
//             }
//         }
//     }

//     useEffect(() => { getData(); }, [BasicTab, currentPage, perPage, searchTerm]);

//     const handleClickPreview = (imageUrl) => {
//         setSelectedImages(imageUrl);
//         setIsPreview(!isPreview);
//     };

//     const toggleBannerStatus = async (row) => {
//         const token = JSON.parse(localStorage.getItem('token'));
//         const action = row.status === 'active' ? 'disable' : 'enable';
//         const confirm = await Swal.fire({
//             title: `${action === 'disable' ? 'Disable' : 'Enable'} this banner?`,
//             text: action === 'disable'
//                 ? 'The banner will stop appearing on the storefront.'
//                 : 'The banner will become visible on the storefront.',
//             icon: 'warning',
//             showCancelButton: true,
//             confirmButtonColor: '#d3178a',
//             cancelButtonColor: '#6c757d',
//             confirmButtonText: action === 'disable' ? 'Yes, disable it' : 'Yes, enable it',
//         });
//         if (!confirm.isConfirmed) return;
//         try {
//             const res = await axios.patch(
//                 `${baseURL}/api/content-management/${row._id}/status`,
//                 {},
//                 { headers: { Authorization: `${token}` } }
//             );
//             if (res?.data?.success) {
//                 getData();
//                 Swal.fire({ title: res.data.message, icon: 'success', confirmButtonColor: '#d3178a' });
//             }
//         } catch (error) {
//             Swal.fire({ title: error?.response?.data?.message || 'Status update failed', icon: 'error', confirmButtonColor: '#d3178a' });
//         }
//     };

//     const formik = useFormik({
//         initialValues: {
//             device_type: "",
//             banner_type: "",
//             theme_type: "",
//             title: "",
//             image: "",
//             links: [],
//             content: "",
//             category_id: "",
//             // Hero banner fields (optional)
//             hero_status_text: "",
//             hero_subtitle: "",
//             hero_btn1_label: "",
//             hero_btn1_link: "",
//             hero_btn2_label: "",
//             hero_btn2_link: "",
//         },
//         validationSchema: Yup.object({
//             device_type: Yup.string().required('Device Type is required'),
//             banner_type: Yup.string().required('Banner Type is required'),
//             theme_type: Yup.string().required('Theme Type is required'),
//             links: Yup.array().of(Yup.string().url('Please enter a valid URL or leave empty')),
//             // category_id required only for category_hero_banner
//             category_id: Yup.string().when('banner_type', {
//                 is: 'category_hero_banner', then: (s) => s.required('Category is required'), otherwise: (s) => s.optional()
//             }),
//         }),
//         onSubmit: async (values) => {
//             setLoading(true);
//             const token = await JSON.parse(localStorage.getItem("token"));
//             try {
//                 // Hero banners: image is mandatory
//                 const isHero = values.banner_type === 'home_hero_banner' || values.banner_type === 'category_hero_banner';
//                 if (isHero && !id && (!files || files.length === 0)) {
//                     setLoading(false);
//                     Swal.fire({ title: 'Banner/Background Image is required for hero banners.', icon: 'warning', confirmButtonColor: '#d3178a' });
//                     return;
//                 }

//                 const formData = new FormData();
//                 values.device_type && formData.append('device_type', values.device_type);
//                 values.banner_type && formData.append('banner_type', values.banner_type);
//                 values.theme_type && formData.append('theme_type', values.theme_type);

//                 // Hero banner: serialise fields into content JSON + title
//                 if (values.banner_type === 'home_hero_banner' || values.banner_type === 'category_hero_banner') {
//                     values.title && formData.append('title', values.title);
//                     const heroContent = JSON.stringify({
//                         status_text: values.hero_status_text,
//                         subtitle: values.hero_subtitle,
//                         btn_primary: { label: values.hero_btn1_label, link: values.hero_btn1_link },
//                         btn_secondary: { label: values.hero_btn2_label, link: values.hero_btn2_link },
//                     });
//                     formData.append('content', heroContent);
//                     if (values.banner_type === 'category_hero_banner' && values.category_id) {
//                         formData.append('category_id', values.category_id);
//                     }
//                 } else {
//                     if (values.links && values.links.length > 0) {
//                         const filteredLinks = values.links.filter(link => link && link.trim() !== '');
//                         if (filteredLinks.length > 0) {
//                             formData.append('links', JSON.stringify(filteredLinks));
//                         }
//                     }
//                 }

//                 if (files && files.length > 0 && files[0] instanceof Blob) {
//                     files.forEach((file, index) => {
//                         let fileName = `image_${index}.${file.type.split("/")[1]}`;
//                         const newFile = new File([file], fileName, { type: file.type });
//                         formData.append(`image_${index}`, newFile);
//                     });
//                 } else if (files && files.length > 0 && !(files[0] instanceof Blob)) {
//                     // If files is a raw File (not a Blob from canvas crop), append directly
//                     const rawFile = files[0];
//                     if (rawFile instanceof File) {
//                         formData.append('image_0', rawFile);
//                     }
//                 }

//                 let response;
//                 if (id) {
//                     response = await axios.patch(`${baseURL}/api/content-management/${id}`, formData, {
//                         headers: { Authorization: `${token}`, "Content-Type": "multipart/form-data" }
//                     })
//                 } else {
//                     response = await axios.post(`${baseURL}/api/content-management/add`, formData, {
//                         headers: { Authorization: `${token}`, "Content-Type": "multipart/form-data" }
//                     });
//                 }
//                 if (response?.data?.success) {
//                     setLoading(false)
//                     formik.resetForm();
//                     toggleModal();
//                     getData();
//                     Swal.fire({ title: response?.data?.message, icon: "success", confirmButtonColor: "#d3178a" });
//                 }
//             } catch (error) {
//                 setLoading(false);
//                 const msg =
//                     typeof error?.response?.data?.message === 'string'
//                         ? error.response.data.message
//                         : error?.message || 'An unexpected error occurred';
//                 Swal.fire({ title: msg, icon: "error", confirmButtonColor: "#d3178a" });
//             }
//         },
//     });

//     const handlePageChange = (page) => { setCurrentPage(page); };
//     const handlePerRowsChange = async (newPerPage, page) => { setPerPage(newPerPage); };

//     const [src, setSrc] = useState(null);
//     const [crop, setCrop] = useState({ aspect: 16 / 5 });
//     const imgRef = useRef(null);

//     // hero banners: mobile 16:9, website 8:3
//     const isHeroBanner = () =>
//         formik.values.banner_type === 'home_hero_banner' || formik.values.banner_type === 'category_hero_banner';

//     const handleFileSelection = (event) => {
//         const selectedFiles = Array.from(event.target.files);
//         handleFiles(selectedFiles);
//     };

//     // 🆕 trade_banner, landing_page_banner, and advertisement_banner all support multiple images
//     const isMultiImageBanner = (bannerType) =>
//         bannerType === "landing_page_banner" || bannerType === "trade_banner" || bannerType === "advertisement_banner";

//     const handleFiles = (fileList) => {
//         const newFiles = [];
//         const newSrcList = [];
//         const newCropList = [];
//         const filteredFiles = isMultiImageBanner(formik.values.banner_type) ? fileList : [fileList[0]];

//         filteredFiles.forEach((file) => {
//             const reader = new FileReader();
//             reader.onload = (e) => {
//                 newFiles.push(file);
//                 newSrcList.push(e.target.result);
//                 newCropList.push({ aspect: 16 / 9 });

//                 if (newFiles.length === filteredFiles.length) {
//                     setFiles(newFiles);
//                     setImages(newSrcList);
//                     setCropList(newCropList);
//                     const newLinks = Array(newFiles.length).fill('');
//                     setLinks(newLinks);
//                     formik.setFieldValue('links', newLinks);
//                 }
//             };
//             reader.readAsDataURL(file);
//         });
//     };

//     const onImageLoaded = (image, index) => {
//         const { naturalWidth: width, naturalHeight: height } = image.currentTarget;
//         let aspectRatio;
//         if (formik.values.banner_type === 'home_hero_banner' || formik.values.banner_type === 'category_hero_banner') {
//             // Hero banners: follow device type — mobile 16:9, website 8:3
//             aspectRatio = formik.values.device_type === 'mobile' ? 16 / 9 : 8 / 3;
//         } else if (formik.values.device_type === "mobile") {
//             aspectRatio = formik.values.banner_type === "category_search_banner" ? 2.19 / 1 : 1 / 1;
//         } else {
//             aspectRatio = formik.values.banner_type === "category_search_banner" ? 11 / 1 : 16 / 5;
//         }
//         const crop = centerCrop(
//             makeAspectCrop({ unit: '%', width: 100 }, aspectRatio, width, height),
//             width, height
//         );
//         setCropList(prevCropList => {
//             const newCropList = [...prevCropList];
//             newCropList[index] = crop;
//             return newCropList;
//         });
//     };

//     const onCropComplete = async (crop, index) => {
//         const image = imgRefs.current[index];
//         const srcContent = image.src;
//         let mimeType = "image/jpeg";
//         if (srcContent && srcContent.startsWith('data:')) {
//             const mimeMatch = srcContent.match(/^data:([^;]+);base64,/);
//             if (mimeMatch && mimeMatch[1]) mimeType = mimeMatch[1];
//         }
//         let blobImg;
//         if (mimeType === 'image/gif') {
//             blobImg = base64ToBlob(`banner_${index}.gif`, srcContent, 'image/gif');
//         } else {
//             blobImg = await generateCroppedImage(image, crop, `banner_${index}.jpeg`, 'image/jpeg');
//         }
//         setFiles(prevFiles => {
//             const newFiles = [...prevFiles];
//             newFiles[index] = blobImg;
//             return newFiles;
//         });
//     };

//     const base64ToBlob = (fileName, base64, mime) => {
//         const parts = base64.split(',');
//         const byteString = atob(parts[1]);
//         const mimeType = parts[0].match(/:(.*?);/)[1];
//         const ab = new ArrayBuffer(byteString.length);
//         const ia = new Uint8Array(ab);
//         for (let i = 0; i < byteString.length; i++) ia[i] = byteString.charCodeAt(i);
//         const blob = new Blob([ia], { type: mimeType });
//         blob.name = fileName;
//         return blob;
//     };

//     const getAspectRatio = (deviceType, bannerType) => {
//         if (deviceType === 'mobile') {
//             if (bannerType === 'category_search_banner') return '(2.19:1)';
//             if (bannerType === 'home_hero_banner' || bannerType === 'category_hero_banner') return '(16:9)';
//             return '(1:1)';
//         } else {
//             if (bannerType === 'category_search_banner') return '(11:1)';
//             if (bannerType === 'home_hero_banner' || bannerType === 'category_hero_banner') return '(8:3)';
//             return '(16:9)';
//         }
//     };

//     const generateCroppedImage = (image, crop, fileName, mimeType) => {
//         const canvas = document.createElement("canvas");
//         const scaleX = image.naturalWidth / image.width;
//         const scaleY = image.naturalHeight / image.height;
//         const pixelRatio = window.devicePixelRatio;
//         canvas.width = crop.width * pixelRatio;
//         canvas.height = crop.height * pixelRatio;
//         const ctx = canvas.getContext("2d");
//         ctx.setTransform(pixelRatio, 0, 0, pixelRatio, 0, 0);
//         ctx.imageSmoothingQuality = "high";
//         ctx.drawImage(image, crop.x * scaleX, crop.y * scaleY, crop.width * scaleX, crop.height * scaleY, 0, 0, crop.width, crop.height);
//         return new Promise((resolve) => {
//             canvas?.toBlob((blob) => { blob.name = fileName; resolve(blob); }, mimeType, 1);
//         });
//     };

//     const renderLinkInputs = () => {
//         // 🆕 Both landing_page_banner and trade_banner support per-image links
//         if (isMultiImageBanner(formik.values.banner_type) && images.length > 0) {
//             return images.map((_, index) => (
//                 <Col xl={6} key={index}>
//                     <FormGroup>
//                         <Label className="font-medium text-base">
//                             Link for Image {index + 1} (Optional)
//                         </Label>
//                         <Input
//                             name={`link_${index}`}
//                             onChange={(e) => handleLinkChange(index, e.target.value)}
//                             value={links[index] || ''}
//                             placeholder={`Enter link for image ${index + 1} (https://example.com)`}
//                             type="url"
//                         />
//                         {formik.touched.links && formik.errors.links && formik.errors.links[index] ? (
//                             <span className="error text-danger">{formik.errors.links[index]}</span>
//                         ) : null}
//                     </FormGroup>
//                 </Col>
//             ));
//         } else if (formik.values.banner_type && !isMultiImageBanner(formik.values.banner_type)) {
//             return (
//                 <Col xl={6}>
//                     <FormGroup>
//                         <Label className="font-medium text-base">Link (Optional)</Label>
//                         <Input
//                             name="single_link"
//                             onChange={(e) => {
//                                 const newLinks = [e.target.value];
//                                 setLinks(newLinks);
//                                 formik.setFieldValue('links', newLinks);
//                             }}
//                             value={links[0] || ''}
//                             placeholder="Enter Banner Link (https://example.com)"
//                             type="url"
//                         />
//                         {formik.touched.links && formik.errors.links && formik.errors.links[0] ? (
//                             <span className="error text-danger">{formik.errors.links[0]}</span>
//                         ) : null}
//                     </FormGroup>
//                 </Col>
//             );
//         }
//         return null;
//     };

//     const handleLinkChange = (index, value) => {
//         const newLinks = [...links];
//         newLinks[index] = value;
//         setLinks(newLinks);
//         formik.setFieldValue('links', newLinks);
//     };

//     const orderColumns = [
//         {
//             name: 'Device', width: '120px',
//             selector: row => `${row.device_type}`, sortable: true, center: true,
//             cell: (row) => capitalize(row?.device_type)
//         },
//         {
//             name: 'Banner Type', width: '250px',
//             selector: row => `${row.banner_type}`, sortable: true, center: true,
//             cell: (row) => row?.banner_type ? (banner_types[row?.banner_type] || row?.banner_type) : "N/A"
//         },
//         {
//             name: 'Theme', width: '100px',
//             selector: row => `${row.theme_type}`, sortable: true, center: true,
//             cell: (row) => capitalize(row?.theme_type)
//         },
//         {
//             name: 'Links',
//             selector: row => row?.links, sortable: false, center: false,
//             cell: (row) => {
//                 let linksArray = [];
//                 if (row?.links) {
//                     if (Array.isArray(row.links)) {
//                         if (row.links.length > 0 && typeof row.links[0] === 'string') {
//                             try { linksArray = JSON.parse(row.links[0]); } catch (e) { return <span className="text-danger">Invalid links format</span>; }
//                         } else { linksArray = row.links; }
//                     } else if (typeof row.links === 'string') {
//                         try { linksArray = JSON.parse(row.links); } catch (e) { return <span className="text-danger">Invalid links format</span>; }
//                     }
//                 }
//                 linksArray = linksArray.filter(link => link && link.trim() !== '');
//                 if (linksArray.length > 0) {
//                     return (
//                         <div className="d-flex flex-column gap-1 py-2">
//                             {linksArray.map((link, index) => {
//                                 const displayText = link.length > 50 ? link.substring(0, 100) + '...' : link;
//                                 return (
//                                     <a key={index} href={link} target="_blank" rel="noopener noreferrer"
//                                         className="text-primary text-decoration-none d-block"
//                                         style={{ fontSize: '0.675rem', wordBreak: 'break-all', maxWidth: '340px' }}
//                                         title={link}>
//                                         <span className='text-black'>Link {index + 1}:</span> {displayText}
//                                     </a>
//                                 );
//                             })}
//                         </div>
//                     );
//                 }
//                 return <span className="text-muted">No Links</span>;
//             }
//         },
//         {
//             name: 'Preview', width: '200px',
//             selector: row => row['full_name'], sortable: true, center: false,
//             cell: (row) => (
//                 <>
//                     {/* home/category hero banner: open the rich hero preview modal */}
//                     {(row.banner_type === 'home_hero_banner' || row.banner_type === 'category_hero_banner') ? (
//                         <Media className='d-flex align-items-center'>
//                             <FaEye size={18} color='#d3178a' />
//                             <span
//                                 onClick={() => {
//                                     const parsed = parseHeroContent(row.content);
//                                     setHeroPreviewData({ ...parsed, title: row.title, bgImage: row.image ? imageURL + row.image : null, device_type: row.device_type });
//                                     setIsHeroPreview(true);
//                                 }}
//                                 className='ms-2 link-primary cursor-pointer'
//                             >
//                                 Click here to preview
//                             </span>
//                         </Media>
//                     ) : row.images && row.images.length > 0 ? (
//                         <Media className='d-flex align-items-center'>
//                             <Image attrImage={{ className: 'rounded-circle w-[30px] h-[30px]', src: `${row?.images[0] ? imageURL + row.images[0] : dummyImg}`, alt: 'Banner image' }} />
//                             <span onClick={() => handleClickPreview(row.images.map(img => imageURL + img))} className='ms-2 link-primary cursor-pointer'>Click here to preview</span>
//                         </Media>
//                     ) : (
//                         <Media className='d-flex align-items-center'>
//                             <Image attrImage={{ className: 'rounded-circle w-[30px] h-[30px]', src: `${row?.image ? imageURL + row.image : dummyImg}`, alt: 'Banner image' }} />
//                             <span onClick={() => handleClickPreview(row?.image ? [imageURL + row.image] : [dummyImg])} className='ms-2 link-primary cursor-pointer'>Click here to preview</span>
//                         </Media>
//                     )}
//                 </>
//             )
//         },
//         {
//             name: 'CREATED', width: '120px',
//             selector: row => `${row.createdAt}`,
//             cell: (row) => moment(row.createdAt).format("DD MMM, YYYY"),
//             sortable: true, center: true,
//         },
//         {
//             name: 'STATUS', width: '110px',
//             selector: row => `${row.status}`, sortable: true, center: true,
//             cell: (row) => row.status === 'active'
//                 ? <span style={{ fontSize: '12px' }} className="badge badge-light-success">Active</span>
//                 : <span style={{ fontSize: '12px' }} className="badge badge-light-danger">Disabled</span>
//         },
//         {
//             name: 'Actions', width: '120px',
//             omit: !canAny(['content.update', 'content.delete']),
//             cell: (row) => (
//                 <UncontrolledDropdown className='action_dropdown'>
//                     <DropdownToggle className='action_btn'><MoreVertical color='#000' size={16} /></DropdownToggle>
//                     <DropdownMenu>
//                         {/* Preview action for home/category hero banners */}
//                         {(row.banner_type === 'home_hero_banner' || row.banner_type === 'category_hero_banner') && (
//                             <DropdownItem onClick={() => {
//                                 const parsed = parseHeroContent(row.content);
//                                 setHeroPreviewData({ ...parsed, title: row.title, bgImage: row.image ? imageURL + row.image : null, device_type: row.device_type });
//                                 setIsHeroPreview(true);
//                             }}>
//                                 Preview <FaEye />
//                             </DropdownItem>
//                         )}
//                         {can('content.update') && (
//                             <DropdownItem onClick={() => {
//                                 formik.resetForm(); getEditData(row); setId(row?._id); SetAddmodal(true)
//                             }}>
//                                 Edit <FaPen />
//                             </DropdownItem>
//                         )}
//                         {/* Enable / Disable toggle */}
//                         {can('content.update') && (
//                             <DropdownItem
//                                 onClick={() => toggleBannerStatus(row)}
//                                 className={row.status === 'active' ? 'text-warning' : 'text-success'}
//                             >
//                                 {row.status === 'active' ? 'Disable' : 'Enable'}
//                                 {' '}{row.status === 'active' ? <FaToggleOff /> : <FaToggleOn />}
//                             </DropdownItem>
//                         )}
//                         {can('content.delete') && (
//                             <DropdownItem className='delete_item' onClick={() => deleteBrand(row?._id)}>
//                                 Delete <FaTrashAlt />
//                             </DropdownItem>
//                         )}
//                     </DropdownMenu>
//                 </UncontrolledDropdown>
//             ),
//             sortable: false, center: true,
//         }
//     ];

//     return (
//         <Fragment>
//             <CardBody style={{ padding: '15px' }}>
//                 <Row xxl={12} className='pb-2'>
//                     <Row>
//                         <Col md={6} lg={6} xl={6} xxl={6}>
//                             <h5 className="fw-bolder">Banners</h5>
//                         </Col>
//                         <Col md={6} lg={6} xl={6} xxl={6}>
//                             <div className="file-content file-content1 justify-content-end">
//                                 <div className='mb-0 form-group position-relative search_outer d-flex align-items-center'>
//                                     <i className='fa fa-search' style={{ top: 'unset' }}></i>
//                                     <input className='form-control border-0' style={{ maxWidth: '195px' }} onChange={(e) => debouncedSearch(e.target.value)} type='text' placeholder='Search...' />
//                                 </div>
//                                 {can('content.create') && (
//                                     <Button className='btn btn-primary d-flex align-items-center ms-3' onClick={toggleModal}>
//                                         <PlusCircle /> Add Banner
//                                     </Button>
//                                 )}
//                             </div>
//                         </Col>
//                     </Row>
//                 </Row>
//             </CardBody>

//             <DataTable
//                 data={data}
//                 columns={orderColumns}
//                 striped={true}
//                 center={true}
//                 pagination
//                 paginationServer
//                 progressComponent={<Loader />}
//                 progressPending={isLoading}
//                 paginationTotalRows={totalRows}
//                 onChangeRowsPerPage={handlePerRowsChange}
//                 onChangePage={handlePageChange}
//             />

//             <CommonModal isOpen={AddModal} title={id ? 'Update Banner' : 'Add a New Banner'} className="store_modal" toggler={toggleModal} size="xl">
//                 <Container>
//                     <Form onSubmit={formik.handleSubmit}>
//                         <Row>
//                             <Col xl={6}>
//                                 <FormGroup>
//                                     <Label className="font-medium text-base">Device Type <span className="text-danger">*</span></Label>
//                                     <Input type="select" name="device_type" onChange={formik.handleChange} onBlur={formik.handleBlur} value={formik.values.device_type}>
//                                         <option value="" disabled label="Select Device Type" />
//                                         <option value="mobile" label="Mobile" />
//                                         <option value="website" label="Website" />
//                                     </Input>
//                                     {formik.touched.device_type && formik.errors.device_type && <span className="error text-danger">{formik.errors.device_type}</span>}
//                                 </FormGroup>
//                             </Col>

//                             <Col xl={6}>
//                                 <FormGroup>
//                                     <Label className="font-medium text-base">Banner Type <span className="text-danger">*</span></Label>
//                                     <Input type="select" name="banner_type" onChange={formik.handleChange} onBlur={formik.handleBlur} value={formik.values.banner_type}>
//                                         <option value="" disabled label="Select Banner Type" />
//                                         <option value="landing_page_banner" label={`Landing Page Banner ${getAspectRatio(formik.values.device_type, 'landing_page_banner')}`} />
//                                         <option value="festival_banner" label={`Festival Banner ${getAspectRatio(formik.values.device_type, 'festival_banner')}`} />
//                                         <option value="subscribe_banner" label={`Subscribe Banner ${getAspectRatio(formik.values.device_type, 'subscribe_banner')}`} />
//                                         <option value="category_search_banner" label={`Category Search Page Banner ${getAspectRatio(formik.values.device_type, 'category_search_banner')}`} />
//                                         <option value="trade_banner" label={`Trade Home Banner ${getAspectRatio(formik.values.device_type, 'trade_banner')}`} />
//                                         <option value="advertisement_banner" label={`Advertisement Banner ${getAspectRatio(formik.values.device_type, 'advertisement_banner')}`} />
//                                         {/* Home Hero Banner */}
//                                         <option value="home_hero_banner" label={`Home Hero Banner ${getAspectRatio(formik.values.device_type, 'home_hero_banner')}`} />
//                                         {/* Category Hero Banner */}
//                                         <option value="category_hero_banner" label={`Category Hero Banner ${getAspectRatio(formik.values.device_type, 'category_hero_banner')}`} />
//                                     </Input>
//                                     {formik.touched.banner_type && formik.errors.banner_type && <span className="error text-danger">{formik.errors.banner_type}</span>}

//                                     {/* 🆕 Helper text for trade banner */}
//                                     {formik.values.banner_type === "trade_banner" && (
//                                         <div className="mt-1 p-2 rounded" style={{ background: "#fff0f7", border: "1px solid #f9a8d4" }}>
//                                             <small className="text-danger font-weight-bold">
//                                                 🏢 Trade Banner — shown only to approved B2B/Trade account users on the homepage.
//                                                 Upload separate banners for mobile and website.
//                                             </small>
//                                         </div>
//                                     )}
//                                     {/* 🆕 Helper text for advertisement banner */}
//                                     {formik.values.banner_type === "advertisement_banner" && (
//                                         <div className="mt-1 p-2 rounded" style={{ background: "#f0f7ff", border: "1px solid #a8d4f9" }}>
//                                             <small className="text-primary font-weight-bold">
//                                                 📢 Advertisement Banner — supports multiple images displayed as a slider on the home page.
//                                                 Upload separate banners for mobile and website.
//                                             </small>
//                                         </div>
//                                     )}
//                                 </FormGroup>
//                             </Col>

//                             <Col xl={6}>
//                                 <FormGroup>
//                                     <Label className="font-medium text-base">Select Theme Type <span className="text-danger">*</span></Label>
//                                     <Input type="select" name="theme_type" onChange={formik.handleChange} onBlur={formik.handleBlur} value={formik.values.theme_type}>
//                                         <option value="" disabled label="Select Theme Type" />
//                                         <option value="light" label="Light" />
//                                         <option value="dark" label="Dark" />
//                                     </Input>
//                                     {formik.touched.theme_type && formik.errors.theme_type && <span className="error text-danger">{formik.errors.theme_type}</span>}
//                                 </FormGroup>
//                             </Col>

//                             {/* Home Hero Banner OR Category Hero Banner — 5-field section (all optional) */}
//                             {(formik.values.banner_type === 'home_hero_banner' || formik.values.banner_type === 'category_hero_banner') && (
//                                 <>
//                                     <Col xl={12}>
//                                         <div className="p-3 rounded mb-3" style={{ background: '#f0f4ff', border: '1px solid #b8c8ff' }}>
//                                             <small className="text-primary fw-bold">
//                                                 {formik.values.banner_type === 'home_hero_banner'
//                                                     ? <><strong>Home Hero Banner</strong> — configures the left-side hero copy on the homepage. Multiple records can exist; toggle Active/Inactive to control which is live.</>
//                                                     : <><strong>Category Hero Banner</strong> — configures the hero copy shown on a specific category page. Select the category below.</>}
//                                             </small>
//                                         </div>
//                                     </Col>

//                                     {/* Category selector — only for category_hero_banner */}
//                                     {formik.values.banner_type === 'category_hero_banner' && (
//                                         <Col xl={12}>
//                                             <FormGroup>
//                                                 <Label className="font-medium text-base">Category <span className="text-danger">*</span></Label>
//                                                 <Input type="select" name="category_id" onChange={formik.handleChange} onBlur={formik.handleBlur} value={formik.values.category_id}>
//                                                     <option value="" disabled>Select Category</option>
//                                                     {categories.map(cat => (
//                                                         <option key={cat._id} value={cat._id}>{cat.collection_name}</option>
//                                                     ))}
//                                                 </Input>
//                                                 {formik.touched.category_id && formik.errors.category_id && <span className="error text-danger">{formik.errors.category_id}</span>}
//                                             </FormGroup>
//                                         </Col>
//                                     )}

//                                     {/* Field 1 — Status Line (optional) */}
//                                     <Col xl={12}>
//                                         <FormGroup>
//                                             <Label className="font-medium text-base">1. Status Line <small className="text-muted">(optional — dot badge text, e.g. "Store open · delivering across Melbourne's north")</small></Label>
//                                             <Input
//                                                 name="hero_status_text"
//                                                 onChange={formik.handleChange}
//                                                 onBlur={formik.handleBlur}
//                                                 value={formik.values.hero_status_text}
//                                                 placeholder="Store open · delivering across Melbourne's north"
//                                             />
//                                         </FormGroup>
//                                     </Col>

//                                     {/* Field 2 — Hero Headline (optional) */}
//                                     <Col xl={12}>
//                                         <FormGroup>
//                                             <Label className="font-medium text-base">2. Hero Headline <small className="text-muted">(optional — main title, e.g. "Cold drinks, delivered in 33 minutes.")</small></Label>
//                                             <Input
//                                                 name="title"
//                                                 onChange={formik.handleChange}
//                                                 onBlur={formik.handleBlur}
//                                                 value={formik.values.title}
//                                                 placeholder="Cold drinks, delivered in 33 minutes."
//                                             />
//                                         </FormGroup>
//                                     </Col>

//                                     {/* Field 3 — Sub-Heading (optional) */}
//                                     <Col xl={12}>
//                                         <FormGroup>
//                                             <Label className="font-medium text-base">3. Sub-Heading <small className="text-muted">(optional — e.g. "Faster than the drive. Colder than the shop. Free over $18.")</small></Label>
//                                             <Input
//                                                 name="hero_subtitle"
//                                                 onChange={formik.handleChange}
//                                                 onBlur={formik.handleBlur}
//                                                 value={formik.values.hero_subtitle}
//                                                 placeholder="Faster than the drive. Colder than the shop. Free over $18."
//                                             />
//                                         </FormGroup>
//                                     </Col>

//                                     {/* Field 4 — Primary Button (optional) */}
//                                     <Col xl={6}>
//                                         <FormGroup>
//                                             <Label className="font-medium text-base">4. Primary Button Label <small className="text-muted">(optional)</small></Label>
//                                             <Input
//                                                 name="hero_btn1_label"
//                                                 onChange={formik.handleChange}
//                                                 onBlur={formik.handleBlur}
//                                                 value={formik.values.hero_btn1_label}
//                                                 placeholder="Shop deals"
//                                             />
//                                         </FormGroup>
//                                     </Col>
//                                     <Col xl={6}>
//                                         <FormGroup>
//                                             <Label className="font-medium text-base">4. Primary Button Link <small className="text-muted">(optional)</small></Label>
//                                             <Input
//                                                 name="hero_btn1_link"
//                                                 onChange={formik.handleChange}
//                                                 onBlur={formik.handleBlur}
//                                                 value={formik.values.hero_btn1_link}
//                                                 placeholder="/collections/biggest-savings"
//                                             />
//                                         </FormGroup>
//                                     </Col>

//                                     {/* Field 5 — Secondary Button (optional) */}
//                                     <Col xl={6}>
//                                         <FormGroup>
//                                             <Label className="font-medium text-base">5. Secondary Button Label <small className="text-muted">(optional)</small></Label>
//                                             <Input
//                                                 name="hero_btn2_label"
//                                                 onChange={formik.handleChange}
//                                                 onBlur={formik.handleBlur}
//                                                 value={formik.values.hero_btn2_label}
//                                                 placeholder="Reorder my usuals"
//                                             />
//                                         </FormGroup>
//                                     </Col>
//                                     <Col xl={6}>
//                                         <FormGroup>
//                                             <Label className="font-medium text-base">5. Secondary Button Link <small className="text-muted">(optional)</small></Label>
//                                             <Input
//                                                 name="hero_btn2_link"
//                                                 onChange={formik.handleChange}
//                                                 onBlur={formik.handleBlur}
//                                                 value={formik.values.hero_btn2_link}
//                                                 placeholder="/account/orders"
//                                             />
//                                         </FormGroup>
//                                     </Col>
//                                 </>
//                             )}

//                             {/* Non-hero banners: show link inputs */}
//                             {formik.values.banner_type !== 'home_hero_banner' && formik.values.banner_type !== 'category_hero_banner' && renderLinkInputs()}

//                             <Col xl={6}>
//                                 <FormGroup>
//                                     <Label className="font-medium text-base">
//                                         {(formik.values.banner_type === 'home_hero_banner' || formik.values.banner_type === 'category_hero_banner')
//                                             ? <>Banner/Background Image <span className="text-danger">*</span></>   
//                                             : 'Banner Image'}
//                                         {formik.values.banner_type !== 'home_hero_banner' && formik.values.banner_type !== 'category_hero_banner' && <span className="text-danger"> *</span>}
//                                         {formik.values.banner_type === "trade_banner" && (
//                                             <small className="text-muted ml-2">(Multiple images supported — will show as slider)</small>
//                                         )}
//                                         {formik.values.banner_type === "advertisement_banner" && (
//                                             <small className="text-muted ml-2">(Multiple images supported — will show as slider)</small>
//                                         )}
//                                     </Label>
//                                     <CardBody>
//                                         <Form>
//                                             <input
//                                                 type="file"
//                                                 multiple={isMultiImageBanner(formik.values.banner_type)}
//                                                 onChange={handleFileSelection}
//                                                 hidden
//                                                 accept="image/png, image/jpeg, image/gif"
//                                                 ref={inputRef}
//                                             />
//                                             <button type="button" className='btn btn-secondary' onClick={() => inputRef.current.click()}>
//                                                 Browse Files
//                                             </button>
//                                         </Form>
//                                     </CardBody>
//                                 </FormGroup>
//                             </Col>

//                             <Col xl={12}>
//                                 <div className='mt-3'>
//                                     {images.length > 0 ? (
//                                         images.map((image, index) => (
//                                             <ReactCrop
//                                                 key={index}
//                                                 crop={cropList[index]}
//                                                 onChange={newCrop => setCropList(prevCrops => {
//                                                     const newCrops = [...prevCrops];
//                                                     newCrops[index] = newCrop;
//                                                     return newCrops;
//                                                 })}
//                                                 onComplete={() => onCropComplete(cropList[index], index)}
//                                                 aspect={
//                                                     isHeroBanner()
//                                                         ? (formik.values.device_type === 'mobile' ? 16 / 9 : 8 / 3)
//                                                         : formik.values.device_type === "mobile"
//                                                             ? 1 / 1
//                                                             : formik.values.banner_type === "category_search_banner"
//                                                                 ? 11 / 1
//                                                                 : 16 / 5
//                                                 }
//                                                 keepSelection={true}
//                                                 minWidth={isHeroBanner()
//                                                     ? (formik.values.device_type === 'mobile' ? 640 : 1920)
//                                                     : formik.values.device_type === "mobile" ? 500 : 1920
//                                                 }
//                                                 minHeight={isHeroBanner()
//                                                     ? (formik.values.device_type === 'mobile' ? 360 : 720)
//                                                     : formik.values.device_type === "mobile" ? 500 : (formik.values.banner_type === "category_search_banner" ? 175 : 500)
//                                                 }
//                                             >
//                                                 <img
//                                                     ref={el => (imgRefs.current[index] = el)}
//                                                     src={image}
//                                                     onLoad={(e) => onImageLoaded(e, index)}
//                                                     alt=''
//                                                 />
//                                             </ReactCrop>
//                                         ))
//                                     ) : (
//                                         <img src={selectedImage} alt='' />
//                                     )}
//                                 </div>

//                                 {/* Hero banner — live in-form preview panel */}
//                                 {(formik.values.banner_type === 'home_hero_banner' || formik.values.banner_type === 'category_hero_banner') && (
//                                     <div className='mt-4'>
//                                         <Label className="fw-bold mb-2">Live Preview</Label>
//                                         <HeroPreviewPanel
//                                             statusText={formik.values.hero_status_text}
//                                             title={formik.values.title}
//                                             subtitle={formik.values.hero_subtitle}
//                                             btn1Label={formik.values.hero_btn1_label}
//                                             btn1Link={formik.values.hero_btn1_link}
//                                             btn2Label={formik.values.hero_btn2_label}
//                                             bgImage={images[0] || selectedImage || null}
//                                             deviceType={formik.values.device_type}
//                                         />
//                                     </div>
//                                 )}
//                             </Col>

//                             <Col xl={12} className="modal_btm d-flex justify-content-end">
//                                 <Button className="cancel_Btn" onClick={() => { setImages([]); SetAddmodal(false) }}>Cancel</Button>
//                                 <Button type="submit" disabled={loading} className='btn btn-primary d-flex align-items-center ms-3'>
//                                     {loading ? 'Uploading…' : (id ? 'Update Banner' : 'Add Banner')}
//                                 </Button>
//                             </Col>
//                         </Row>
//                     </Form>
//                     <UploadOverlay
//                         isVisible={loading}
//                         message={id ? 'Updating banner…' : 'Saving banner…'}
//                     />
//                 </Container>
//             </CommonModal>


//             <CommonModal isOpen={isPreview} className="store_modal" toggler={() => setIsPreview(!isPreview)} size="lg">
//                 <Container>
//                     <Row>
//                         {selectedImages.map && selectedImages.map((image, index) => (
//                             <Col xl={12} md={12} sm={12} key={index}>
//                                 <img src={image} className='w-100' alt={`banner-${index}`} />
//                             </Col>
//                         ))}
//                     </Row>
//                 </Container>
//             </CommonModal>

//             {/* 🆕 Hero Banner — full-screen preview modal */}
//             <CommonModal
//                 isOpen={isHeroPreview}
//                 title="Hero Banner Preview"
//                 className="store_modal"
//                 toggler={() => setIsHeroPreview(false)}
//                 size="xl"
//             >
//                 <Container fluid>
//                     {heroPreviewData && (
//                         <HeroPreviewPanel
//                             statusText={heroPreviewData.status_text}
//                             title={heroPreviewData.title}
//                             subtitle={heroPreviewData.subtitle}
//                             btn1Label={heroPreviewData.btn_primary?.label}
//                             btn1Link={heroPreviewData.btn_primary?.link}
//                             btn2Label={heroPreviewData.btn_secondary?.label}
//                             bgImage={heroPreviewData.bgImage}
//                             deviceType={heroPreviewData.device_type}
//                         />
//                     )}
//                 </Container>
//             </CommonModal>
//         </Fragment>
//     )
// }

// // Reusable hero preview component — renders the storefront hero left-body
// function HeroPreviewPanel({ statusText, title, subtitle, btn1Label, btn1Link, btn2Label, bgImage, deviceType }) {
//     const hasAnyContent = statusText || title || subtitle || btn1Label || btn2Label;
//     const isMobile = deviceType === 'mobile';
//     return (
//         <div style={{
//             background: bgImage ? `url(${bgImage}) center/cover no-repeat` : 'linear-gradient(135deg, #1a1a2e 0%, #16213e 50%, #0f3460 100%)',
//             borderRadius: '12px',
//             // Mobile: 16:9 landscape; Website: 8:3 wide panel
//             ...(isMobile
//                 ? { aspectRatio: '16 / 9', width: '100%', maxWidth: '480px', padding: '24px' }
//                 : { aspectRatio: '8 / 3', width: '100%', padding: '48px 40px' }
//             ),
//             display: 'flex',
//             alignItems: isMobile ? 'flex-end' : 'center',
//             position: 'relative',
//             overflow: 'hidden',
//         }}>
//             {bgImage && <div style={{ position: 'absolute', inset: 0, background: 'rgba(0,0,0,0.45)', borderRadius: '12px' }} />}
//             {hasAnyContent && (
//                 <div style={{ position: 'relative', zIndex: 1, maxWidth: '520px' }}>
//                     {/* Status dot badge — only if provided */}
//                     {statusText && (
//                         <p style={{ display: 'flex', alignItems: 'center', gap: '8px', color: '#a3e635', fontSize: '13px', fontWeight: 600, marginBottom: '16px', letterSpacing: '0.02em' }}>
//                             <span style={{ width: '8px', height: '8px', borderRadius: '50%', background: '#a3e635', display: 'inline-block', boxShadow: '0 0 8px #a3e635' }} />
//                             {statusText}
//                         </p>
//                     )}

//                     {/* Headline — only if provided */}
//                     {title && (
//                         <h1 style={{ color: '#fff', fontSize: '2.2rem', fontWeight: 800, lineHeight: 1.15, margin: '0 0 14px' }}>
//                             {title}
//                         </h1>
//                     )}

//                     {/* Sub-heading — only if provided */}
//                     {subtitle && (
//                         <p style={{ color: '#cbd5e1', fontSize: '15px', marginBottom: '28px', lineHeight: 1.6 }}>{subtitle}</p>
//                     )}

//                     {/* Buttons — only render the row if at least one button label exists */}
//                     {(btn1Label || btn2Label) && (
//                         <div style={{ display: 'flex', gap: '12px', flexWrap: 'wrap' }}>
//                             {btn1Label && (
//                                 <span style={{
//                                     background: '#d3178a', color: '#fff', padding: '10px 24px',
//                                     borderRadius: '8px', fontWeight: 700, fontSize: '14px', cursor: 'default',
//                                     boxShadow: '0 4px 14px rgba(211,23,138,0.4)'
//                                 }}>{btn1Label}</span>
//                             )}
//                             {btn2Label && (
//                                 <span style={{
//                                     background: 'transparent', color: '#fff', padding: '10px 24px',
//                                     borderRadius: '8px', fontWeight: 600, fontSize: '14px', cursor: 'default',
//                                     border: '1.5px solid rgba(255,255,255,0.35)'
//                                 }}>{btn2Label}</span>
//                             )}
//                         </div>
//                     )}
//                 </div>
//             )}
//         </div>
//     );
// }

// export default ContentManagementTable;





// import React, { Fragment, useState, useEffect, useRef } from 'react'
// import DataTable from 'react-data-table-component';
// import { Button, CardBody, Col, Container, DropdownItem, DropdownMenu, DropdownToggle, Form, FormGroup, Input, InputGroup, InputGroupText, Label, Media, Nav, NavItem, NavLink, Row, UncontrolledDropdown } from 'reactstrap';
// import { MoreVertical, PlusCircle } from 'react-feather';
// import useRbac from '../../../../Hooks/useRbac';
// import CommonModal from '../../../UiKits/Modals/common/modal'
// import axios from 'axios';
// import moment from 'moment';
// import Swal from 'sweetalert2';
// import { useFormik } from 'formik';
// import * as Yup from 'yup'
// import { baseURL, imageURL } from '../../../../Services/api/baseURL';
// import dummyImg from '../../../../assets/images/product/2.png';
// import { Image } from '../../../../AbstractElements';
// import { FaPen, FaTrashAlt } from 'react-icons/fa';
// import { debounce } from 'lodash';
// import Loader from '../../../Loader/Loader';
// import ReactCrop, { centerCrop, makeAspectCrop } from 'react-image-crop';
// import 'react-image-crop/dist/ReactCrop.css'

// export const spinnerData = [{
//     id: 33,
//     heading: 'Loader 31',
//     spinnerClass: 'loader-35'
// }]

// function ContentManagementTable() {
//     const { can, canAny } = useRbac();
//     const [editData, setEditData] = useState();
//     const [searchTerm, setSearchTerm] = useState('');
//     const [AddModal, SetAddmodal] = useState(false);
//     const [data, setData] = useState([])
//     const [deleteModal, setDeleteModal] = useState(false);
//     const [token, setToken] = useState(null);
//     const [image, setImage] = useState("");
//     const [id, setId] = useState("");
//     const [BasicTab, setBasicTab] = useState('storePartner');
//     const [currentPage, setCurrentPage] = useState(1);
//     const [totalRows, setTotalRows] = useState(0);
//     const [perPage, setPerPage] = useState(10);
//     const [isLoading, setIsLoading] = useState(false);
//     const [loading, setLoading] = useState(false);
//     const [files, setFiles] = useState([]);
//     const [previews, setPreviews] = useState([]);
//     const [selectedImage, setSelectedImage] = useState('');
//     const [selectedImages, setSelectedImages] = useState([]);
//     const [isPreview, setIsPreview] = useState(false);
//     const inputRef = useRef();
//     const [images, setImages] = useState([]);
//     const imgRefs = useRef([]);
//     const [cropList, setCropList] = useState([]);
//     const cropperRef = useRef(null);
//     const [links, setLinks] = useState([]);

//     const banner_types = {
//         subscribe_banner: "Subscribe Banner",
//         festival_banner: "Festival Banner",
//         landing_page_banner: "Landing Page Banner",
//         category_search_banner: "Category Search Page Banner",
//         none: ""
//     };

//     useEffect(() => {
//         const token = JSON.parse(localStorage.getItem('token'))
//         if (token) {
//             setToken(token);
//             return;
//         }
//         setToken(null);
//     }, []);

//     const toggleModal = () => {
//         formik.resetForm();
//         setId("");
//         SetAddmodal(!AddModal);
//         setFiles([]);
//         setSrc("");
//         setImage("");
//         setCrop();
//         setLoading(false);
//         setSelectedImage("");
//         setImages([]);
//         setLinks([]);
//     };

//     const debouncedSearch = React.useRef(
//         debounce(async (searchTerm) => {
//             setSearchTerm(searchTerm);
//         }, 300)
//     ).current;

//     function capitalize(word) {
//         const lower = word?.toLowerCase();
//         return word?.charAt(0).toUpperCase() + lower?.slice(1);
//     }

//     const getEditData = async (data) => {
//         if (data) {
//             data.device_type && formik.setFieldValue("device_type", data.device_type);
//             data.banner_type && formik.setFieldValue("banner_type", data.banner_type);
//             data.theme_type && formik.setFieldValue("theme_type", data.theme_type);
//             if (!data.links || !Array.isArray(data.links)) {
//                 const newLinks = Array(data.images.length).fill('');
//                 setLinks(newLinks);
//                 formik.setFieldValue("links", newLinks);
//             }


//             if (data?.image) {
//                 const imgSrc = imageURL + data?.image;
//                 setFiles(data?.image);
//                 setSelectedImage(imgSrc)
//             }
//             if (data?.images && data.images.length > 0) {
//                 const imgList = [];
//                 data.images.forEach((img) => { imgList.push(imageURL + img) });
//                 setFiles(imgList);
//                 setSelectedImages(imgList)
//             }

//         }
//     }

//     const getData = async () => {
//         const token = await JSON.parse(localStorage.getItem("token"))
//         try {
//             setIsLoading(true);
//             let endPoint = '/api/content-management/list';

//             const response = await axios.get(`${baseURL}${endPoint}?page=${currentPage}&limit=${perPage}&search_string=${searchTerm}`, {
//                 headers: {
//                     Authorization: `${token}`,
//                 }
//             });

//             if (response?.data.success) {
//                 setData(response?.data?.data);
//                 setTotalRows(response?.data.total);
//                 setIsLoading(false);
//             }
//         } catch (error) {
//             console.log(error)
//             setIsLoading(true);

//         }
//     }

//     const deleteBrand = async (id) => {
//         if (window.confirm("Do You Want To Delete this Content?")) {
//             const token = await JSON.parse(localStorage.getItem("token"))
//             try {
//                 const data = await axios.delete(`${baseURL}/api/content-management/${id}`, {
//                     headers: {
//                         Authorization: `${token}`,
//                     }
//                 })
//                 getData();
//                 Swal.fire({
//                     icon: 'success',
//                     title: data?.data?.message
//                 })
//             } catch (error) {
//                 console.log(error, 'edit')
//             }
//         }
//     }

//     useEffect(() => {
//         getData();
//     }, [BasicTab, currentPage, perPage, searchTerm]);

//     const handleClickPreview = (imageUrl) => {
//         setSelectedImages(imageUrl)
//         setIsPreview(!isPreview);
//     };

//     const formik = useFormik({
//         initialValues: {
//             device_type: "",
//             banner_type: "",
//             theme_type: "",
//             title: "",
//             image: "",
//             links: [],
//             content: ""
//         },
//         validationSchema: Yup.object({
//             device_type: Yup.string().required('Device Type is required'),
//             banner_type: Yup.string().required('Banner Type is required'),
//             theme_type: Yup.string().required('Theme Type is required'),
//             links: Yup.array().of(Yup.string().url('Please enter a valid URL or leave empty')),
//         }),
//         onSubmit: async (values) => {
//             setLoading(true);
//             const token = await JSON.parse(localStorage.getItem("token"));
//             try {
//                 const formData = new FormData();
//                 values.device_type && formData.append('device_type', values.device_type);
//                 values.banner_type && formData.append('banner_type', values.banner_type);
//                 values.theme_type && formData.append('theme_type', values.theme_type);

//                 if (values.links && values.links.length > 0) {
//                     const filteredLinks = values.links.filter(link => link && link.trim() !== '');
//                     if (filteredLinks.length > 0) {
//                         formData.append('links', JSON.stringify(filteredLinks));
//                     }
//                 }

//                 if (files) {
//                     files.forEach((file, index) => {
//                         let fileName = `image_${index}.${file.type.split("/")[1]}`;
//                         const newFile = new File([file], fileName, { type: file.type });
//                         formData.append(`image_${index}`, newFile);
//                     });

//                     formData.forEach((value, key) => {
//                     });
//                 }

//                 let response;
//                 formData.forEach((value, key) => {
//                 });

//                 if (id) {

//                     response = await axios.patch(`${baseURL}/api/content-management/${id}`,
//                         formData,
//                         {
//                             headers: {
//                                 Authorization: `${token}`,
//                                 "Content-Type": "multipart/form-data",
//                             }
//                         })
//                 }
//                 else {

//                     response = await axios.post(`${baseURL}/api/content-management/add`,
//                         formData,
//                         {
//                             headers: {
//                                 Authorization: `${token}`,
//                                 "Content-Type": "multipart/form-data",
//                             }
//                         });
//                 }
//                 if (response?.data?.success) {
//                     setLoading(false)
//                     formik.resetForm();
//                     toggleModal();
//                     getData();
//                     Swal.fire({
//                         title: response?.data?.message,
//                         icon: "success",
//                         confirmButtonColor: "#d3178a",
//                     });
//                 }
//             } catch (error) {
//                 setLoading(false);
//                 Swal.fire({
//                     title: error?.response?.data?.message,
//                     icon: "error",
//                     confirmButtonColor: "#d3178a",
//                 });
//             }
//         },
//     });

//     const handlePageChange = (page) => {
//         setCurrentPage(page);
//     };

//     const handlePerRowsChange = async (newPerPage, page) => {
//         setPerPage(newPerPage);
//     };

//     const [src, setSrc] = useState(null);
//     const [crop, setCrop] = useState({ aspect: formik.values.banner_type === "category_search_banner" ? 11 / 1 : 16 / 5 });
//     const imgRef = useRef(null);

//     const handleFileSelection = (event) => {
//         const selectedFiles = Array.from(event.target.files);
//         handleFiles(selectedFiles);
//     };

//     const handleFiles = (fileList) => {
//         const newFiles = [];
//         const newSrcList = [];
//         const newCropList = [];
//         const filteredFiles = formik.values.banner_type === "landing_page_banner" ? fileList : [fileList[0]];

//         filteredFiles.forEach((file) => {
//             const reader = new FileReader();

//             reader.onload = (e) => {
//                 newFiles.push(file);
//                 newSrcList.push(e.target.result);
//                 newCropList.push({ aspect: 16 / 9 });

//                 if (newFiles.length === filteredFiles.length) {
//                     setFiles(newFiles);
//                     setImages(newSrcList);
//                     setCropList(newCropList);
//                     const newLinks = Array(newFiles.length).fill('');
//                     setLinks(newLinks);
//                     formik.setFieldValue('links', newLinks);
//                 }
//             };

//             reader.readAsDataURL(file);
//         });
//     };

//     const onImageLoaded = (image, index) => {
//         const { naturalWidth: width, naturalHeight: height } = image.currentTarget;

//         let aspectRatio;
//         if (formik.values.device_type === "mobile") {
//             aspectRatio = formik.values.banner_type === "category_search_banner" ? 2.19 / 1 : 1 / 1;
//         } else {
//             aspectRatio = formik.values.banner_type === "category_search_banner" ? 11 / 1 : 16 / 5;
//         }
//         const crop = centerCrop(
//             makeAspectCrop(
//                 {
//                     unit: '%',
//                     width: 100,
//                 },
//                 aspectRatio,
//                 width,
//                 height
//             ),
//             width,
//             height
//         );
//         setCropList(prevCropList => {
//             const newCropList = [...prevCropList];
//             newCropList[index] = crop;
//             return newCropList;
//         });
//     };

//     const onCropComplete = async (crop, index) => {
//         const image = imgRefs.current[index];
//         const srcContent = image.src;
//         let mimeType = "image/jpeg";

//         if (srcContent) {
//             const dataUri = srcContent;
//             if (dataUri.startsWith('data:')) {
//                 const mimeMatch = dataUri.match(/^data:([^;]+);base64,/);
//                 if (mimeMatch && mimeMatch[1]) {
//                     mimeType = mimeMatch[1];
//                 }
//             }
//         }
//         console.log(mimeType)
//         let blobImg;
//         if (mimeType === 'image/gif') {
//             const base64String = srcContent;
//             blobImg = base64ToBlob(`banner_${index}.gif`, base64String, 'image/gif');

//         } else {
//             console.log(crop, "banner.jpeg", "image/jpeg");
//             blobImg = await generateCroppedImage(image, crop, `banner_${index}.jpeg`, 'image/jpeg');
//         }
//         setFiles(prevFiles => {
//             const newFiles = [...prevFiles];
//             newFiles[index] = blobImg;
//             return newFiles;
//         });
//     };

//     const base64ToBlob = (fileName, base64, mime) => {
//         const parts = base64.split(',');
//         const byteString = atob(parts[1]);
//         const mimeType = parts[0].match(/:(.*?);/)[1];
//         const ab = new ArrayBuffer(byteString.length);
//         const ia = new Uint8Array(ab);
//         for (let i = 0; i < byteString.length; i++) {
//             ia[i] = byteString.charCodeAt(i);
//         }

//         const blob = new Blob([ia], { type: mimeType });
//         blob.name = fileName;

//         return blob;

//     };

//     const getAspectRatio = (deviceType, bannerType) => {
//         if (deviceType === 'mobile') {
//             if (bannerType === 'category_search_banner') {
//                 return '(2.19:1)';
//             } else {
//                 return '(1:1)';
//             }
//         } else {
//             // For website
//             if (bannerType === 'category_search_banner') {
//                 return '(11:1)';
//             } else {
//                 return '(16:9)';
//             }
//         }
//     };

//     const generateCroppedImage = (image, crop, fileName, mimeType) => {
//         const canvas = document.createElement("canvas");
//         const scaleX = image.naturalWidth / image.width;
//         const scaleY = image.naturalHeight / image.height;
//         canvas.width = crop.width;
//         canvas.height = crop.height;
//         const ctx = canvas.getContext("2d");
//         const pixelRatio = window.devicePixelRatio;
//         canvas.width = crop.width * pixelRatio;
//         canvas.height = crop.height * pixelRatio;
//         ctx.setTransform(pixelRatio, 0, 0, pixelRatio, 0, 0);
//         ctx.imageSmoothingQuality = "high";

//         ctx.drawImage(
//             image,
//             crop.x * scaleX,
//             crop.y * scaleY,
//             crop.width * scaleX,
//             crop.height * scaleY,
//             0,
//             0,
//             crop.width,
//             crop.height
//         );

//         return new Promise((resolve, reject) => {
//             canvas?.toBlob(
//                 (blob) => {
//                     blob.name = fileName;
//                     resolve(blob);
//                 },
//                 mimeType,
//                 1
//             );
//         });

//     };

//     const renderLinkInputs = () => {
//         if (formik.values.banner_type === "landing_page_banner" && images.length > 0) {
//             return images.map((_, index) => (
//                 <Col xl={6} key={index}>
//                     <FormGroup>
//                         <Label className="font-medium text-base">
//                             Link for Image {index + 1} (Optional)
//                         </Label>
//                         <Input
//                             name={`link_${index}`}
//                             onChange={(e) => handleLinkChange(index, e.target.value)}
//                             value={links[index] || ''}
//                             placeholder={`Enter link for image ${index + 1} (https://example.com)`}
//                             type="url"
//                         />
//                         {formik.touched.links && formik.errors.links && formik.errors.links[index] ? (
//                             <span className="error text-danger">{formik.errors.links[index]}</span>
//                         ) : null}
//                     </FormGroup>
//                 </Col>
//             ));
//         } else if (formik.values.banner_type && formik.values.banner_type !== "landing_page_banner") {
//             return (
//                 <Col xl={6}>
//                     <FormGroup>
//                         <Label className="font-medium text-base">
//                             Link (Optional)
//                         </Label>
//                         <Input
//                             name="single_link"
//                             onChange={(e) => {
//                                 const newLinks = [e.target.value];
//                                 setLinks(newLinks);
//                                 formik.setFieldValue('links', newLinks);
//                             }}
//                             value={links[0] || ''}
//                             placeholder="Enter Banner Link (https://example.com)"
//                             type="url"
//                         />
//                         {formik.touched.links && formik.errors.links && formik.errors.links[0] ? (
//                             <span className="error text-danger">{formik.errors.links[0]}</span>
//                         ) : null}
//                     </FormGroup>
//                 </Col>
//             );
//         }
//         return null;
//     };

//     const handleLinkChange = (index, value) => {
//         const newLinks = [...links];
//         newLinks[index] = value;
//         setLinks(newLinks);
//         formik.setFieldValue('links', newLinks);
//     };


//     const orderColumns = [
//         {
//             name: 'Device',
//             width: '120px',
//             selector: row => `${row.device_type}`,
//             sortable: true,
//             center: true,
//             cell: (row) => (
//                 capitalize(row?.device_type)
//             )
//         },
//         {
//             name: 'Banner Type',
//             width: '250px',
//             selector: row => `${row.banner_type}`,
//             sortable: true,
//             center: true,
//             cell: (row) => (
//                 row?.banner_type ? banner_types[row?.banner_type] : "N/A"
//             )
//         },
//         {
//             name: 'Theme',
//             width: '100px',
//             selector: row => `${row.theme_type}`,
//             sortable: true,
//             center: true,
//             cell: (row) => (
//                 capitalize(row?.theme_type)
//             )
//         },
//         {
//             name: 'Links',
//             selector: row => row?.links,
//             sortable: false,
//             center: false,
//             cell: (row) => {
//                 let linksArray = [];

//                 if (row?.links) {
//                     if (Array.isArray(row.links)) {
//                         if (row.links.length > 0 && typeof row.links[0] === 'string') {
//                             try {
//                                 linksArray = JSON.parse(row.links[0]);
//                             } catch (e) {
//                                 console.error('JSON Parse Error:', e);
//                                 return <span className="text-danger">Invalid links format</span>;
//                             }
//                         } else {
//                             linksArray = row.links;
//                         }
//                     } else if (typeof row.links === 'string') {
//                         try {
//                             linksArray = JSON.parse(row.links);
//                         } catch (e) {
//                             console.error('JSON Parse Error:', e);
//                             return <span className="text-danger">Invalid links format</span>;
//                         }
//                     }
//                 }

//                 linksArray = linksArray.filter(link => link && link.trim() !== '');

//                 if (linksArray.length > 0) {
//                     return (
//                         <div className="d-flex flex-column gap-1 py-2">
//                             {linksArray.map((link, index) => {
//                                 const displayText = link.length > 50 ? link.substring(0, 100) + '...' : link;

//                                 return (
//                                     <a
//                                         key={index}
//                                         href={link}
//                                         target="_blank"
//                                         rel="noopener noreferrer"
//                                         className="text-primary text-decoration-none d-block"
//                                         style={{
//                                             fontSize: '0.675rem',
//                                             wordBreak: 'break-all',
//                                             maxWidth: '340px'
//                                         }}
//                                         title={link}
//                                     >
//                                         <span className='text-black'>Link {index + 1}:</span>  {displayText}
//                                     </a>
//                                 );
//                             })}
//                         </div>
//                     );
//                 }
//                 return <span className="text-muted">No Links</span>;
//             }
//         }
//         ,
//         {
//             name: 'Preview',
//             width: '200px',
//             selector: row => row['full_name'],
//             sortable: true,
//             center: false,
//             cell: (row) => (
//                 <>
//                     {row.images && row.images.length > 0 ? (<Media className='d-flex align-items-center'>
//                         <Image attrImage={{ className: ' rounded-circle w-[30px] h-[30px]', src: `${row?.images[0] ? imageURL + row.images[0] : dummyImg}`, alt: 'Brand image' }} />
//                         <span onClick={() => { handleClickPreview(row.images.map(img => imageURL + img)) }} className='ms-2 link-primary cursor-pointer'>   {capitalize('Click here to preview')}</span>
//                     </Media>) : (
//                         <Media className='d-flex align-items-center'>
//                             <Image attrImage={{ className: ' rounded-circle w-[30px] h-[30px]', src: `${row?.image ? imageURL + row.image : dummyImg}`, alt: 'Brand image' }} />
//                             <span onClick={() => { handleClickPreview(row?.image ? [imageURL + row.image] : [dummyImg]) }} className='ms-2 link-primary cursor-pointer'> {capitalize('CLick here to preview')}</span>
//                         </Media>)}
//                 </>

//             )
//         },
//         {
//             name: 'CREATED',
//             width: '120px',
//             selector: row => `${row.createdAt}`,
//             cell: (row) => (
//                 moment(row.createdAt).format("DD MMM, YYYY")
//             ),
//             sortable: true,
//             center: true,
//         },
//         {
//             name: 'STATUS',
//             width: '100px',
//             selector: row => `${row.updatedAt}`,
//             sortable: true,
//             center: true,
//             cell: (row) => (
//                 <span style={{ fontSize: '13px' }} className={`badge badge-light-success`}>
//                     Active
//                 </span>
//             ),
//         },
//         {
//             name: 'Actions',
//             width: '100px',
//             omit: !canAny(['content.update', 'content.delete']),
//             cell: (row) => (
//                 <>
//                     <UncontrolledDropdown className='action_dropdown'>
//                         <DropdownToggle className='action_btn'
//                         >
//                             <MoreVertical color='#000' size={16} />
//                         </DropdownToggle>
//                         <DropdownMenu>
//                             {can('content.update') && <DropdownItem onClick={() => {
//                                 formik.resetForm();
//                                 getEditData(row);
//                                 setId(row?._id);
//                                 SetAddmodal(true)
//                             }}>
//                                 Edit
//                                 <FaPen />
//                             </DropdownItem>}
//                             {can('content.delete') && <DropdownItem className='delete_item' onClick={(rowData) => {
//                                 deleteBrand(row?._id);
//                             }}>
//                                 Delete
//                                 <FaTrashAlt />
//                             </DropdownItem>}
//                         </DropdownMenu>
//                     </UncontrolledDropdown>
//                 </>
//             ),
//             sortable: false,
//             center: true,
//         }
//     ];
//     return (
//         <Fragment>
//             <CardBody style={{ padding: '15px' }}>
//                 <Row xxl={12} className='pb-2'>
//                     <Row>
//                         <Col md={6} lg={6} xl={6} xxl={6}>
//                             <div>
//                                 {/* <h4 className='mb-0'>
//                                     Hero’s Banner
//                                 </h4> */}
//                                  <h5 className="fw-bolder">Banners</h5>
//                             </div>
//                         </Col>
//                         <Col md={6} lg={6} xl={6} xxl={6}>
//                             <div className="file-content file-content1 justify-content-end">
//                                 <div className='mb-0 form-group position-relative search_outer d-flex align-items-center'>
//                                     <i className='fa fa-search' style={{ top: 'unset' }}></i>
//                                     <input className='form-control border-0' style={{ maxWidth: '195px' }} onChange={(e) => debouncedSearch(e.target.value)} type='text' placeholder='Search...' />
//                                 </div>
//                                 {can('content.create') && <Button className='btn btn-primary d-flex align-items-center ms-3' onClick={toggleModal}>
//                                     <PlusCircle />
//                                     Add Banner
//                                 </Button>}
//                             </div>
//                         </Col>
//                     </Row>
//                 </Row>
//             </CardBody>

//             <DataTable
//                 data={data}
//                 columns={orderColumns}
//                 striped={true}
//                 center={true}
//                 pagination
//                 paginationServer
//                 progressComponent={<Loader />}
//                 progressPending={isLoading}
//                 paginationTotalRows={totalRows}
//                 onChangeRowsPerPage={handlePerRowsChange}
//                 onChangePage={handlePageChange}
//             />

//             <CommonModal isOpen={AddModal} title={id ? 'Update Banner' : 'Add a New Banner'} className="store_modal" toggler={toggleModal} size="xl">
//                 <Container>
//                     <Form onSubmit={formik.handleSubmit}>
//                         <Row>
//                             <Col xl={6}>
//                                 <FormGroup>
//                                     <Label className="font-medium text-base">
//                                         Device Type <span className="text-danger">*</span>
//                                     </Label>
//                                     <Input
//                                         type="select"
//                                         name="device_type"
//                                         onChange={formik.handleChange}
//                                         onBlur={formik.handleBlur}
//                                         value={formik.values.device_type}
//                                     >
//                                         <option value="" disabled selected label="Select Device Type" />
//                                         <option value="mobile" label="Mobile" />
//                                         <option value="website" label="Website" />
//                                     </Input>
//                                     {formik.touched.device_type && formik.errors.device_type ? (
//                                         <span className="error text-danger">{formik.errors.device_type}</span>
//                                     ) : (
//                                         ""
//                                     )}
//                                 </FormGroup>
//                             </Col>

//                             <Col xl={6}>
//                                 <FormGroup>
//                                     <Label className="font-medium text-base">
//                                         Banner Type <span className="text-danger">*</span>
//                                     </Label>
//                                     <Input
//                                         type="select"
//                                         name="banner_type"
//                                         onChange={(e) => {
//                                             formik.handleChange(e);
//                                         }}
//                                         onBlur={formik.handleBlur}
//                                         value={formik.values.banner_type}
//                                     >
//                                         <option value="" disabled selected label="Select Banner Type" />
//                                         <option value="landing_page_banner"
//                                             label={`Landing Page Banner ${getAspectRatio(formik.values.device_type, 'landing_page_banner')}`} />
//                                         <option value="festival_banner"
//                                             label={`Festival Banner ${getAspectRatio(formik.values.device_type, 'festival_banner')}`} />
//                                         <option value="subscribe_banner"
//                                             label={`Subscribe Banner ${getAspectRatio(formik.values.device_type, 'subscribe_banner')}`} />
//                                         <option value="category_search_banner"
//                                             label={`Category Search Page Banner ${getAspectRatio(formik.values.device_type, 'category_search_banner')}`} />
//                                     </Input>
//                                     {formik.touched.banner_type && formik.errors.banner_type ? (
//                                         <span className="error text-danger">{formik.errors.banner_type}</span>
//                                     ) : (
//                                         ""
//                                     )}
//                                 </FormGroup>
//                             </Col>

//                             <Col xl={6}>
//                                 <FormGroup>
//                                     <Label className="font-medium text-base">
//                                         Select Theme Type <span className="text-danger">*</span>
//                                     </Label>
//                                     <Input
//                                         type="select"
//                                         name="theme_type"
//                                         onChange={formik.handleChange}
//                                         onBlur={formik.handleBlur}
//                                         value={formik.values.theme_type}
//                                     >
//                                         <option value="" disabled selected label="Select Theme Type" />
//                                         <option value="light" label="Light" />
//                                         <option value="dark" label="Dark" />
//                                     </Input>
//                                     {formik.touched.theme_type && formik.errors.theme_type ? (
//                                         <span className="error text-danger">{formik.errors.theme_type}</span>
//                                     ) : (
//                                         ""
//                                     )}
//                                 </FormGroup>
//                             </Col>
//                             {renderLinkInputs()}


//                             <Col xl={6}>
//                                 <FormGroup>
//                                     <Label className="font-medium text-base">
//                                         Banner Image <span className="text-danger">*</span>
//                                     </Label>
//                                     <CardBody>
//                                         <Form>
//                                             <input
//                                                 type="file"
//                                                 multiple
//                                                 onChange={handleFileSelection}
//                                                 hidden
//                                                 accept="image/png, image/jpeg, image/gif"
//                                                 ref={inputRef}
//                                             />
//                                             <button type="button" className='btn btn-secondary' onClick={() => inputRef.current.click()}>
//                                                 Browse Files
//                                             </button>
//                                         </Form>
//                                     </CardBody>
//                                     {formik.touched.identityImages && formik.errors.identityImages ? (
//                                         <span className="error text-danger">{formik.errors.identityImages}</span>
//                                     ) : (
//                                         ""
//                                     )}
//                                 </FormGroup>
//                             </Col>

//                             <Col xl={12}>
//                                 <div className='mt-3'>
//                                     {
//                                         images.length > 0 ? (images.map((image, index) => (
//                                             <ReactCrop
//                                                 key={index}
//                                                 crop={cropList[index]}
//                                                 onChange={newCrop => setCropList(prevCrops => {
//                                                     const newCrops = [...prevCrops];
//                                                     newCrops[index] = newCrop;
//                                                     return newCrops;
//                                                 })}
//                                                 onComplete={() => onCropComplete(cropList[index], index)}
//                                                 aspect={formik.values.device_type === "mobile" ? 1 / 1 : (formik.values.banner_type === "category_search_banner" ? 11 / 1 : 16 / 5)}
//                                                 keepSelection={true}
//                                                 minWidth={formik.values.device_type === "mobile" ? 500 : 1920}
//                                                 minHeight={formik.values.device_type === "mobile" ? 500 : (formik.values.banner_type === "category_search_banner" ? 175 : 500)}
//                                             >
//                                                 <img
//                                                     ref={el => (imgRefs.current[index] = el)}
//                                                     src={image}
//                                                     onLoad={(e) => onImageLoaded(e, index)}
//                                                     alt=''
//                                                 />
//                                             </ReactCrop>
//                                         )))
//                                             :
//                                             <img src={selectedImage} alt='' />
//                                     }
//                                 </div></Col>

//                             <Col xl={12} className="modal_btm d-flex justify-content-end">
//                                 <Button className="cancel_Btn" onClick={() => { setImages([]); SetAddmodal(false) }}>
//                                     Cancel
//                                 </Button>
//                                 <Button type="submit" disabled={loading} className='btn btn-primary d-flex align-items-center ms-3'>
//                                     {id ? "Update Banner" : "Add Banner"}
//                                 </Button>
//                             </Col>
//                         </Row>
//                     </Form>
//                 </Container>
//             </CommonModal>

//             <CommonModal isOpen={isPreview} className="store_modal" toggler={() => setIsPreview(!isPreview)} size="lg">
//                 <Container>
//                     <Row>
//                         {selectedImages.map((image, index) => (
//                             <Col xl={12} md={12} sm={12} key={index}>
//                                 <img src={image} className='w-100' alt={`banner-${index}`} />
//                             </Col>
//                         ))}
//                     </Row>
//                 </Container>
//             </CommonModal>
//         </Fragment>
//     )
// }

// export default ContentManagementTable;
